<template>
  <v-app>
    <div class="torneo-background">
      <v-main class="torneo-main">
        <TorneoContextBar
          :nombre="nombreTorneo"
          :categoria="categoriaTorneo"
          :tipoCompetencia="tipoCompetenciaTorneo"
          :genero="generoTorneo"
          :estado="estadoTorneo"
          :idTorneo="idTorneo"
          :idInstitucion="idInstitucion"
          :hay-cambios-sin-guardar="hayCambiosSinGuardar"
          :camepon="campeon"
          sistema-competencia="Torneo"
          :deporte="deporte"
          @guardar="guardarCambios"
          @volver="volver"
          @cambiarEstado="cambiarEstado"
          @finalizaTorneo="confirmaFinalizacionTorneo"
        />
        <!-- TABS PRINCIPALES -->
        <v-tabs
          v-model="tab"
          grow
          background-color="transparent"
          class="torneo-tabs"
        >
          <v-tab>Configuración</v-tab>
          <v-tab :disabled="!torneo || modalidad === 'eliminacion_directa'">
            Zonas
            <v-icon v-if="modalidad === 'eliminacion_directa'" right small>
              mdi-lock
            </v-icon>
          </v-tab>
          <v-tab :disabled="!torneo">Fase Eliminación</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- TAB 1: CONFIGURACIÓN -->
          <v-tab-item>
            <v-card class="glass-card" elevation="16">
              <v-card-title class="headline">Configurar Torneo</v-card-title>
              <v-card-text class="py-4">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="total"
                      type="number"
                      label="Total Equipos"
                      min="1"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-select
                      class="mt-0"
                      v-model="modalidad"
                      :items="modalidades"
                      label="Modalidad"
                      outlined
                    ></v-select>
                  </v-col>

                  <v-col
                    v-if="modalidad === 'zonas_y_eliminacion'"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="clasificados"
                      type="number"
                      label="Total Clasificados"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col
                    v-if="modalidad === 'zonas_y_eliminacion'"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="zonasDeseadas"
                      type="number"
                      label="Cantidad de Zonas (opcional)"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col v-if="modalidad === 'zonas_y_eliminacion'" cols="12">
                    <v-select
                      v-model="estrategiaByes"
                      :items="estrategiasByes"
                      label="Estrategia de BYEs (en caso de haber)"
                      outlined
                    ></v-select>
                    <v-alert
                      v-if="estrategiaByes === 'orden_zonas'"
                      type="info"
                      dense
                      class="mt-2"
                    >
                      BYEs para los primeros de las primeras zonas (1º de zona
                      1, 1º de zona 2, etc.)
                    </v-alert>
                    <v-alert v-else type="info" dense class="mt-2">
                      BYEs para los mejor clasificados globalmente (1º mejor 1º,
                      2º mejor 1º, etc.)
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      class="btn-generar-torneo"
                      color="#1976d2"
                      large
                      dark
                      :disabled="estadoTorneo === 'Finalizado'"
                      @click="generarTorneoClick"
                    >
                      <v-icon left color="white">mdi-trophy</v-icon>
                      {{ torneo?.rondas?.length ? "Re-" : "" }}Generar Partidos
                      con la configuración elegida
                    </v-btn>
                    <span
                      v-if="torneo?.rondas?.length"
                      class="torneo-configurado"
                      >Torneo con configuración activa</span
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- TAB 2: ZONAS -->
          <v-tab-item>
            <v-card v-if="torneo">
              <v-card-title class="headline">
                Zonas - Fixture y Tabla de Posiciones
              </v-card-title>

              <!-- ALERTA SI HAY RESULTADOS EN ELIMINACIÓN -->
              <v-alert
                v-if="hayResultadosEnFaseEliminacion()"
                type="warning"
                class="mx-4"
                dense
              >
                <div class="d-flex align-center">
                  <span
                    >Ya hay partidos jugados en fase de eliminación. Si desea
                    cambiar algún resultado, restaure los cruces.</span
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    color="error"
                    @click="resetearCruces"
                    class="ml-2"
                  >
                    <v-icon left small>mdi-restore</v-icon>
                    Restaurar Cruces
                  </v-btn>
                </div>
              </v-alert>

              <v-card-text>
                <!-- DRAG & DROP DE ZONAS -->
                <div v-if="torneo?.zonas" class="zonas-draggable">
                  <v-card class="mb-4" light elevation="16">
                    <v-card-title class="subtitle-1">
                      <v-icon left>mdi-drag</v-icon>
                      Editar Zonas (Arrastrar y Soltar equipos para cambiarlos
                      de zona)
                    </v-card-title>

                    <v-card-text>
                      <v-row>
                        <v-col
                          v-for="zona in torneo.zonas"
                          :key="zona.id"
                          cols="12"
                          md="4"
                          lg="3"
                        >
                          <v-card
                            light
                            class="zona-card"
                            @dragover.prevent="onZonaDragOver"
                            @dragleave="onZonaDragLeave"
                            @drop="onZonaDrop($event, zona)"
                            :class="{
                              'drag-over-zone': zonaDragOver === zona.id,
                            }"
                          >
                            <v-card-title class="subtitle-2">
                              {{ zona.nombre }}
                              <v-chip small class="ml-2">
                                {{ zona.equipos.length }} equipos
                              </v-chip>
                            </v-card-title>

                            <v-card-text>
                              <!-- LISTA DE EQUIPOS -->
                              <v-list dense>
                                <v-list-item
                                  v-for="equipo in zona.equipos"
                                  :key="equipo.id"
                                  draggable="true"
                                  @dragstart="
                                    onEquipoDragStartZona($event, equipo, zona)
                                  "
                                  @dragend="onEquipoDragEnd"
                                  class="equipo-item"
                                >
                                  <v-list-item-content>
                                    <v-list-item-title class="equipo-nombre">
                                      <v-tooltip bottom>
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="text-truncate"
                                          >
                                            {{ equipo.nombre }}
                                          </span>
                                        </template>

                                        <span>{{ equipo.nombre }}</span>
                                      </v-tooltip>
                                    </v-list-item-title>
                                  </v-list-item-content>

                                  <!-- MENÚ DROPDOWN -->
                                  <v-list-item-action>
                                    <!-- MENÚ DROPDOWN EN ZONAS -->
                                    <v-menu
                                      offset-y
                                      left
                                      :disabled="
                                        estadoTorneo === 'Finalizado' ||
                                        hayResultadosEnFaseEliminacion()
                                      "
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn
                                          icon
                                          small
                                          v-bind="attrs"
                                          v-on="on"
                                          :disabled="
                                            estadoTorneo === 'Finalizado' ||
                                            hayResultadosEnFaseEliminacion()
                                          "
                                        >
                                          <v-icon color="white" small
                                            >mdi-dots-vertical</v-icon
                                          >
                                        </v-btn>
                                      </template>

                                      <v-list dense>
                                        <!-- FÚTBOL: Editar Nombre -->
                                        <v-list-item
                                          v-if="!usaJugadores"
                                          @click="
                                            editarNombreEquipoFutbol(
                                              equipo,
                                              zona,
                                            )
                                          "
                                        >
                                          <v-list-item-icon>
                                            <v-icon small color="primary"
                                              >mdi-pencil</v-icon
                                            >
                                          </v-list-item-icon>
                                          <v-list-item-title>
                                            Editar Nombre del Equipo
                                          </v-list-item-title>
                                        </v-list-item>

                                        <!-- TENIS/PADEL: Asignar Jugadores -->
                                        <v-list-item
                                          v-if="usaJugadores"
                                          @click="
                                            editarNombreEquipo(zona, equipo)
                                          "
                                        >
                                          <v-list-item-icon>
                                            <v-icon small color="primary"
                                              >mdi-pencil</v-icon
                                            >
                                          </v-list-item-icon>
                                          <v-list-item-title>
                                            Asignar Jugadores
                                          </v-list-item-title>
                                        </v-list-item>

                                        <!-- TENIS/PADEL: Resetear Jugadores -->
                                        <v-list-item
                                          v-if="usaJugadores"
                                          @click="
                                            resetearJugadoresEquipo(
                                              equipo,
                                              zona,
                                            )
                                          "
                                        >
                                          <v-list-item-icon>
                                            <v-icon small color="warning"
                                              >mdi-account-remove</v-icon
                                            >
                                          </v-list-item-icon>
                                          <v-list-item-title>
                                            Resetear Jugadores
                                          </v-list-item-title>
                                        </v-list-item>

                                        <v-divider></v-divider>

                                        <!-- COMÚN: Eliminar Equipo -->
                                        <v-list-item
                                          @click="eliminarEquipo(zona, equipo)"
                                        >
                                          <v-list-item-icon>
                                            <v-icon small color="error"
                                              >mdi-delete</v-icon
                                            >
                                          </v-list-item-icon>
                                          <v-list-item-title
                                            class="error--text"
                                          >
                                            Eliminar equipo
                                          </v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </v-list-item-action>
                                </v-list-item>
                              </v-list>

                              <v-btn
                                block
                                small
                                color="primary"
                                @click="agregarEquipo(zona)"
                                :disabled="
                                  hayResultadosEnFaseEliminacion() ||
                                  estadoTorneo === 'Finalizado'
                                "
                                class="mt-2"
                              >
                                <v-icon left small>mdi-plus</v-icon>
                                Agregar Equipo
                              </v-btn>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-alert color="success" dark v-if="torneo">
                            <strong>Clasifican: </strong
                            >{{ torneo.criterioClasificacion }}
                          </v-alert>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- TABLAS POR ZONA -->
                  <v-row v-for="zona in torneo.zonas" :key="zona.id">
                    <v-col cols="12">
                      <v-card class="mb-6" light>
                        <v-card-title class="headline">
                          {{ zona.nombre }}
                        </v-card-title>

                        <v-tabs v-model="zonaTabs[zona.id]" grow>
                          <v-tab>Fixture</v-tab>
                          <v-tab>Tabla de Posiciones</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="zonaTabs[zona.id]">
                          <!-- TAB 1: FIXTURE -->
                          <v-tab-item>
                            <v-card-text>
                              <v-data-table
                                :headers="headersPartidos"
                                :items="zona.partidos"
                                class="elevation-1 tabla-partidos"
                                locale="es-ar"
                                item-key="id"
                                mobile-breakpoint="880"
                                :items-per-page="20"
                                ref="myTable"
                                :disable-sort="true"
                                :footer-props="{
                                  'items-per-page-options': [10, 20, 50, -1],
                                  itemsPerPageText: 'Filas por página',
                                }"
                              >
                                <template v-slot:item.local="{ item }">
                                  <span
                                    :class="{
                                      'ganador-border':
                                        item.ganador &&
                                        item.ganador.id === item.local?.id,
                                      'perdedor-border':
                                        item.ganador &&
                                        item.ganador.id === item.visitante?.id,
                                    }"
                                  >
                                    {{ item.local.nombre }}
                                  </span>
                                </template>
                                <template v-slot:item.vs>
                                  <span>vs</span>
                                </template>
                                <template v-slot:item.visitante="{ item }">
                                  <span
                                    :class="{
                                      'ganador-border':
                                        item.ganador &&
                                        item.ganador.id === item.visitante?.id,
                                      'perdedor-border':
                                        item.ganador &&
                                        item.ganador.id === item.local?.id,
                                    }"
                                  >
                                    {{ item.visitante.nombre }}
                                  </span>
                                </template>
                                <template v-slot:item.detalles="{ item }">
                                  <div v-if="item.detalles">
                                    <v-chip
                                      v-if="item.detalles.fecha"
                                      medium
                                      class="mr-1 mb-1"
                                      color="indigo"
                                      dark
                                    >
                                      <span class="detalle-icon">📅</span>

                                      {{ item.detalles.fecha }}
                                    </v-chip>
                                    <v-chip
                                      v-if="item.detalles.hora"
                                      medium
                                      class="mr-1 mb-1"
                                      color="indigo"
                                      dark
                                    >
                                      <span class="detalle-icon">⏰</span>
                                      {{ item.detalles.hora }}
                                    </v-chip>
                                    <v-chip
                                      v-if="item.detalles.lugar"
                                      medium
                                      class="mr-1 mb-1"
                                      color="indigo"
                                      dark
                                    >
                                      <span class="detalle-icon">📍</span>
                                      {{ item.detalles.lugar }}
                                    </v-chip>
                                  </div>
                                  <span v-else class="text-caption grey--text"
                                    >Sin detalles</span
                                  >
                                </template>

                                <template v-slot:item.actions="{ item }">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        small
                                        color="primary"
                                        @click="abrirModalDetalles(item)"
                                        :disabled="
                                          hayResultadosEnFaseEliminacion() ||
                                          estadoTorneo === 'Finalizado'
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small>mdi-calendar</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Cargar Detalles</span>
                                  </v-tooltip>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        small
                                        color="success"
                                        @click="
                                          abrirModalResultadoConAdvertencia(
                                            item,
                                          )
                                        "
                                        :disabled="
                                          hayResultadosEnFaseEliminacion() ||
                                          estadoTorneo === 'Finalizado'
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small>mdi-soccer</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Cargar Resultado</span>
                                  </v-tooltip>
                                </template>
                                <template v-slot:item.estado="{ item }">
                                  <v-chip
                                    v-if="item.resultado"
                                    color="success"
                                    medium
                                  >
                                    <v-icon left small>mdi-check</v-icon>
                                    Jugado
                                  </v-chip>
                                  <v-chip v-else color="warning" medium>
                                    <v-icon left small>mdi-clock</v-icon>
                                    Pendiente
                                  </v-chip>
                                </template>
                              </v-data-table>
                            </v-card-text>
                          </v-tab-item>

                          <v-tab-item>
                            <v-card-text>
                              <v-simple-table class="zonas-tabla">
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-left">Equipo</th>
                                      <th class="text-left">Pts</th>
                                      <th class="text-left">PJ</th>
                                      <th class="text-left">PG</th>
                                      <!-- ⭐ NUEVO: Columna PE solo para fútbol -->
                                      <th
                                        v-if="deporte === 'Futbol'"
                                        class="text-left"
                                      >
                                        PE
                                      </th>
                                      <th class="text-left">PP</th>
                                      <!-- ⭐ CONDICIONAL: Sets solo si NO es fútbol -->
                                      <th
                                        v-if="deporte !== 'Futbol'"
                                        class="text-left"
                                      >
                                        Sets +/−
                                      </th>
                                      <!-- ⭐ ADAPTATIVO: Goles o Games según deporte -->
                                      <th class="text-left">
                                        {{
                                          deporte === "Futbol"
                                            ? "Goles"
                                            : "Games"
                                        }}
                                        +/−
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="fila in calcularTablaZona(
                                        zona,
                                        deporte,
                                      )"
                                      :key="fila.equipo.id"
                                    >
                                      <td class="text-left">
                                        <strong>{{
                                          fila.equipo?.nombre
                                        }}</strong>
                                      </td>
                                      <td class="text-left">
                                        <strong>{{ fila.puntos }}</strong>
                                      </td>
                                      <td class="text-left">{{ fila.pj }}</td>
                                      <td class="text-left">{{ fila.pg }}</td>
                                      <!-- ⭐ NUEVO: Mostrar empates solo para fútbol -->
                                      <td
                                        v-if="deporte === 'Futbol'"
                                        class="text-left"
                                      >
                                        {{ fila.pe }}
                                      </td>
                                      <td class="text-left">{{ fila.pp }}</td>
                                      <!-- ⭐ CONDICIONAL: Diferencia de sets solo para tenis/padel -->
                                      <td
                                        v-if="deporte !== 'Futbol'"
                                        class="text-left"
                                      >
                                        {{ fila.setsDiff > 0 ? "+" : ""
                                        }}{{ fila.setsDiff }}
                                      </td>
                                      <!-- ⭐ ADAPTATIVO: Diferencia de games/goles -->
                                      <td class="text-left">
                                        {{ fila.gamesDiff > 0 ? "+" : ""
                                        }}{{ fila.gamesDiff }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>

                              <!-- ⭐ NUEVO: Leyenda adaptada según deporte -->
                              <v-card-text
                                class="text-caption grey--text text--darken-1 pt-2"
                              >
                                <v-chip x-small class="mr-2 mb-1"
                                  >Pts: Puntos</v-chip
                                >
                                <v-chip x-small class="mr-2 mb-1"
                                  >PJ: Partidos Jugados</v-chip
                                >
                                <v-chip x-small class="mr-2 mb-1"
                                  >PG: Partidos Ganados</v-chip
                                >
                                <v-chip
                                  v-if="deporte === 'Futbol'"
                                  x-small
                                  class="mr-2 mb-1"
                                >
                                  PE: Partidos Empatados
                                </v-chip>
                                <v-chip x-small class="mr-2 mb-1"
                                  >PP: Partidos Perdidos</v-chip
                                >
                                <v-chip
                                  v-if="deporte !== 'Futbol'"
                                  x-small
                                  class="mr-2 mb-1"
                                >
                                  Sets +/−: Diferencia de Sets
                                </v-chip>
                                <v-chip x-small class="mr-2 mb-1">
                                  {{ deporte === "Futbol" ? "Goles" : "Games" }}
                                  +/−: Diferencia de
                                  {{ deporte === "Futbol" ? "Goles" : "Games" }}
                                </v-chip>
                              </v-card-text>
                            </v-card-text>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-card>
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>

            <v-alert v-else type="info" class="mt-4">
              <v-icon left>mdi-information</v-icon>
              Primero debe generar un torneo desde la pestaña "Configuración"
            </v-alert>
          </v-tab-item>

          <!-- TAB 3: FASE ELIMINACIÓN -->
          <v-tab-item>
            <div v-if="torneo" class="bracket-container">
              <v-card class="glass-card">
                <v-card-title class="headline bracket-title">
                  <v-icon left>mdi-tournament</v-icon>
                  Fase de Eliminación
                  <v-spacer></v-spacer>
                  <span
                    v-if="
                      torneo.byes &&
                      modalidad === 'eliminacion_directa' &&
                      deporte === 'Futbol'
                    "
                    class="mensaje-byes"
                    >Para hacer efectivos los byes, edite el equipo
                    correspondiente.</span
                  >
                  <span
                    v-if="
                      torneo.byes &&
                      modalidad === 'eliminacion_directa' &&
                      deporte !== 'Futbol'
                    "
                    class="mensaje-byes"
                    >Para hacer efectivos los byes, asigne los jugadres al
                    equipo.</span
                  >
                  <div
                    v-if="torneo.rondas[0]?.partidos"
                    class="bracket-controls"
                  >
                    <v-btn
                      v-if="
                        !todosResultadosZonas &&
                        modalidad === 'zonas_y_eliminacion'
                      "
                      @click="toggleEdicionPredicciones"
                      :color="
                        habilitarEdicionPredicciones ? 'error' : 'primary'
                      "
                      small
                      class="mr-2"
                      :disabled="!torneo.rondas[0]?.partidos"
                    >
                      <v-icon left small>
                        {{
                          habilitarEdicionPredicciones
                            ? "mdi-close"
                            : "mdi-pencil"
                        }}
                      </v-icon>
                      {{
                        habilitarEdicionPredicciones
                          ? "Finalizar Edición"
                          : "Editar Cruces"
                      }}
                    </v-btn>

                    <v-btn
                      v-if="todosResultadosZonas && torneo.rondas[0]?.partidos"
                      @click="resetearCruces"
                      color="warning"
                      small
                    >
                      <v-icon left small>mdi-restore</v-icon>
                      Restaurar Cruces
                    </v-btn>
                  </div>
                </v-card-title>

                <v-card-text>
                  <!-- INSTRUCCIONES -->
                  <v-alert
                    v-if="!todosResultadosZonas && habilitarEdicionPredicciones"
                    type="info"
                    dense
                    class="mb-4"
                    border="left"
                  >
                    <strong>Modo Edición de Cruces:</strong> Arrastra las
                    predicciones para reorganizar los cruces. Los equipos
                    respetarán esta distribución cuando se carguen los
                    resultados de zonas.
                  </v-alert>

                  <!-- BRACKET -->
                  <div class="rondas-wrapper">
                    <div class="rondas-container" ref="rondasContainer">
                      <div class="rondas">
                        <div
                          v-for="ronda in torneo.rondas"
                          :key="ronda.numero"
                          class="ronda-columna"
                        >
                          <v-card class="ronda-header mb-2" color="primary">
                            <v-card-text class="text-center py-2">
                              <strong class="nombre-ronda">{{
                                obtenerNombreRonda(
                                  ronda.numero,
                                  torneo.rondas.length,
                                )
                              }}</strong>
                              <span
                                v-if="
                                  ronda.numero === 1 && todosResultadosZonas
                                "
                                style="color: white"
                                class="caption ml-2"
                              >
                                (Arrastra para intercambiar)
                              </span>
                            </v-card-text>
                          </v-card>

                          <div class="partidos-contenedor">
                            <v-card
                              v-for="partido in ronda.partidos"
                              :key="partido.id"
                              class="match-card mb-3"
                              :class="{
                                'match-completado': partido.ganador,
                                'match-pendiente':
                                  !partido.ganador &&
                                  partido.local &&
                                  partido.visitante,
                                'match-bye': partido.pasaAutomatico,
                                'editable-prediccion':
                                  !todosResultadosZonas &&
                                  habilitarEdicionPredicciones,
                                'elevation-3': !partido.ganador,
                                'elevation-1': partido.ganador,
                              }"
                              :ref="(el) => (partidoRefs[partido.id] = el)"
                            >
                              <!-- ENCABEZADO CON DETALLES -->
                              <v-card-title class="py-2 match-header">
                                <div
                                  class="d-flex justify-space-between align-center fase-detalles"
                                >
                                  <v-chip small color="grey darken-1" dark>
                                    P{{ partido.id }}
                                  </v-chip>

                                  <div
                                    v-if="partido.detalles"
                                    class="match-detalles-header"
                                  >
                                    <v-chip
                                      v-if="partido.detalles.fecha"
                                      x-small
                                      class="mr-1 mb-1"
                                    >
                                      <v-icon x-small left>mdi-calendar</v-icon>
                                      {{ partido.detalles.fecha }}
                                    </v-chip>
                                    <v-chip
                                      v-if="partido.detalles.hora"
                                      x-small
                                      class="mr-1 mb-1"
                                    >
                                      <v-icon x-small left>mdi-clock</v-icon>
                                      {{ partido.detalles.hora }}
                                    </v-chip>
                                    <v-chip
                                      v-if="partido.detalles.lugar"
                                      x-small
                                      class="mr-1"
                                    >
                                      <v-icon x-small left
                                        >mdi-map-marker</v-icon
                                      >
                                      {{ partido.detalles.lugar }}
                                    </v-chip>
                                  </div>
                                </div>
                              </v-card-title>

                              <v-divider></v-divider>

                              <!-- CONTENIDO DEL PARTIDO -->
                              <v-card-text class="py-3">
                                <!-- CONDICIÓN 1: RONDA 1 EN ELIMINACIÓN DIRECTA O CON EQUIPOS REALES -->
                                <div
                                  v-if="
                                    partido.ronda === 1 &&
                                    (modalidad === 'eliminacion_directa' ||
                                      todosResultadosZonas)
                                  "
                                >
                                  <div class="equipos-ronda1">
                                    <!-- Equipo local -->
                                    <v-card
                                      class="equipo-draggable mb-2"
                                      :class="[
                                        'equipo-linea',
                                        {
                                          ganador:
                                            partido.ganador?.id ===
                                            partido.local?.id,
                                          'disabled-drag':
                                            partido.ganador ||
                                            partido.pasaAutomatico,
                                        },
                                      ]"
                                      :draggable="
                                        !(
                                          partido.ganador ||
                                          partido.pasaAutomatico
                                        ) && modalidad === 'zonas_y_eliminacion'
                                      "
                                      @dragstart="
                                        modalidad === 'zonas_y_eliminacion' &&
                                          onEquipoDragStart(
                                            $event,
                                            partido.local,
                                            partido,
                                            'local',
                                          )
                                      "
                                      @dragover.prevent="
                                        modalidad === 'zonas_y_eliminacion' &&
                                          onEquipoDragOver($event)
                                      "
                                      @drop="
                                        modalidad === 'zonas_y_eliminacion' &&
                                          onEquipoDrop($event, partido, 'local')
                                      "
                                      @dragleave="
                                        modalidad === 'zonas_y_eliminacion' &&
                                          onEquipoDragLeave
                                      "
                                      outlined
                                      flat
                                    >
                                      <v-card-text
                                        class="py-2 d-flex align-center"
                                      >
                                        <v-icon
                                          v-if="
                                            !(
                                              partido.ganador ||
                                              partido.pasaAutomatico
                                            ) &&
                                            modalidad === 'zonas_y_eliminacion'
                                          "
                                          small
                                          class="drag-handle mr-2"
                                        >
                                          mdi-drag-vertical
                                        </v-icon>
                                        <span class="equipo-nombre flex-grow-1">
                                          {{ partido.local?.nombre ?? "—" }}
                                        </span>
                                        <!-- Solo mostrar posición si es zonas y eliminación -->
                                        <v-chip
                                          v-if="
                                            partido.local &&
                                            modalidad === 'zonas_y_eliminacion'
                                          "
                                          x-small
                                          color="grey darken-1"
                                          class="posicion-indicator"
                                        >
                                          {{
                                            obtenerPosicionEquipo(partido.local)
                                          }}
                                        </v-chip>
                                        <!-- MENÚ DROPDOWN para LOCAL (solo eliminación directa) -->
                                        <v-menu
                                          v-if="
                                            modalidad ===
                                              'eliminacion_directa' &&
                                            esObjetoEquipo(partido.local)
                                          "
                                          offset-y
                                          left
                                          :disabled="
                                            estadoTorneo === 'Finalizado'
                                          "
                                        >
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              icon
                                              small
                                              v-bind="attrs"
                                              v-on="on"
                                              :disabled="
                                                estadoTorneo === 'Finalizado'
                                              "
                                              class="ml-2"
                                            >
                                              <v-icon color="white" small
                                                >mdi-dots-vertical</v-icon
                                              >
                                            </v-btn>
                                          </template>

                                          <v-list dense>
                                            <!-- FÚTBOL: Editar Nombre -->
                                            <v-list-item
                                              v-if="!usaJugadores"
                                              @click="
                                                editarNombreEquipoEliminacion(
                                                  partido,
                                                  ronda,
                                                  'local',
                                                )
                                              "
                                            >
                                              <v-list-item-icon>
                                                <v-icon small color="primary"
                                                  >mdi-pencil</v-icon
                                                >
                                              </v-list-item-icon>
                                              <v-list-item-title>
                                                Editar Nombre del Equipo
                                              </v-list-item-title>
                                            </v-list-item>

                                            <!-- TENIS/PADEL: Asignar Jugadores -->
                                            <v-list-item
                                              v-if="usaJugadores"
                                              @click="
                                                editarNombreEquipoEliminacion(
                                                  partido,
                                                  ronda,
                                                  'local',
                                                )
                                              "
                                            >
                                              <v-list-item-icon>
                                                <v-icon small color="primary"
                                                  >mdi-pencil</v-icon
                                                >
                                              </v-list-item-icon>
                                              <v-list-item-title>
                                                Asignar Jugadores
                                              </v-list-item-title>
                                            </v-list-item>

                                            <!-- TENIS/PADEL: Resetear Jugadores -->
                                            <v-list-item
                                              v-if="usaJugadores"
                                              @click="
                                                resetearJugadoresEquipoEliminacion(
                                                  partido,
                                                  'local',
                                                )
                                              "
                                            >
                                              <v-list-item-icon>
                                                <v-icon small color="warning"
                                                  >mdi-account-remove</v-icon
                                                >
                                              </v-list-item-icon>
                                              <v-list-item-title>
                                                Resetear Jugadores
                                              </v-list-item-title>
                                            </v-list-item>
                                          </v-list>
                                        </v-menu>
                                      </v-card-text>
                                    </v-card>

                                    <div class="vs-line text-center my-1">
                                      <v-chip x-small color="grey lighten-2"
                                        >VS</v-chip
                                      >
                                    </div>

                                    <!-- Equipo visitante -->
                                    <v-card
                                      class="equipo-draggable"
                                      :class="[
                                        'equipo-linea',
                                        {
                                          ganador:
                                            partido.ganador?.id ===
                                            partido.visitante?.id,
                                          'disabled-drag':
                                            partido.ganador ||
                                            partido.pasaAutomatico,
                                        },
                                      ]"
                                      :draggable="
                                        !(
                                          partido.ganador ||
                                          partido.pasaAutomatico
                                        ) && modalidad === 'zonas_y_eliminacion'
                                      "
                                      @dragstart="
                                        modalidad === 'zonas_y_eliminacion' &&
                                          onEquipoDragStart(
                                            $event,
                                            partido.visitante,
                                            partido,
                                            'visitante',
                                          )
                                      "
                                      @dragover.prevent="
                                        modalidad === 'zonas_y_eliminacion' &&
                                          onEquipoDragOver($event)
                                      "
                                      @drop="
                                        modalidad === 'zonas_y_eliminacion' &&
                                          onEquipoDrop(
                                            $event,
                                            partido,
                                            'visitante',
                                          )
                                      "
                                      @dragleave="
                                        modalidad === 'zonas_y_eliminacion' &&
                                          onEquipoDragLeave
                                      "
                                      outlined
                                      flat
                                    >
                                      <v-card-text
                                        class="py-2 d-flex align-center"
                                      >
                                        <v-icon
                                          v-if="
                                            !(
                                              partido.ganador ||
                                              partido.pasaAutomatico
                                            ) &&
                                            modalidad === 'zonas_y_eliminacion'
                                          "
                                          small
                                          class="drag-handle mr-2"
                                        >
                                          mdi-drag-vertical
                                        </v-icon>
                                        <span class="equipo-nombre flex-grow-1">
                                          {{ partido.visitante?.nombre ?? "—" }}
                                        </span>
                                        <!-- Solo mostrar posición si es zonas y eliminación -->
                                        <v-chip
                                          v-if="
                                            partido.visitante &&
                                            modalidad === 'zonas_y_eliminacion'
                                          "
                                          x-small
                                          color="grey darken-1"
                                          class="posicion-indicator"
                                        >
                                          {{
                                            obtenerPosicionEquipo(
                                              partido.visitante,
                                            )
                                          }}
                                        </v-chip>
                                        <!-- MENÚ DROPDOWN para VISITANTE (solo eliminación directa) -->
                                        <v-menu
                                          v-if="
                                            modalidad ===
                                              'eliminacion_directa' &&
                                            esObjetoEquipo(partido.local)
                                          "
                                          offset-y
                                          left
                                          :disabled="
                                            estadoTorneo === 'Finalizado'
                                          "
                                        >
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              icon
                                              small
                                              v-bind="attrs"
                                              v-on="on"
                                              :disabled="
                                                estadoTorneo === 'Finalizado'
                                              "
                                              class="ml-2"
                                            >
                                              <v-icon color="white" small
                                                >mdi-dots-vertical</v-icon
                                              >
                                            </v-btn>
                                          </template>

                                          <v-list dense>
                                            <!-- FÚTBOL: Editar Nombre -->
                                            <v-list-item
                                              v-if="!usaJugadores"
                                              @click="
                                                editarNombreEquipoEliminacion(
                                                  partido,
                                                  ronda,
                                                  'visitante',
                                                )
                                              "
                                            >
                                              <v-list-item-icon>
                                                <v-icon small color="primary"
                                                  >mdi-pencil</v-icon
                                                >
                                              </v-list-item-icon>
                                              <v-list-item-title>
                                                Editar Nombre del Equipo
                                              </v-list-item-title>
                                            </v-list-item>

                                            <!-- TENIS/PADEL: Asignar Jugadores -->
                                            <v-list-item
                                              v-if="usaJugadores"
                                              @click="
                                                editarNombreEquipoEliminacion(
                                                  partido,
                                                  ronda,
                                                  'visitante',
                                                )
                                              "
                                            >
                                              <v-list-item-icon>
                                                <v-icon small color="primary"
                                                  >mdi-pencil</v-icon
                                                >
                                              </v-list-item-icon>
                                              <v-list-item-title>
                                                Asignar Jugadores
                                              </v-list-item-title>
                                            </v-list-item>

                                            <!-- TENIS/PADEL: Resetear Jugadores -->
                                            <v-list-item
                                              v-if="usaJugadores"
                                              @click="
                                                resetearJugadoresEquipoEliminacion(
                                                  partido,
                                                  'visitante',
                                                )
                                              "
                                            >
                                              <v-list-item-icon>
                                                <v-icon small color="warning"
                                                  >mdi-account-remove</v-icon
                                                >
                                              </v-list-item-icon>
                                              <v-list-item-title>
                                                Resetear Jugadores
                                              </v-list-item-title>
                                            </v-list-item>
                                          </v-list>
                                        </v-menu>
                                      </v-card-text>
                                    </v-card>
                                  </div>
                                </div>

                                <!-- CONDICIÓN 2: RONDA 1 CON PREDICCIONES (solo zonas y eliminación sin resultados) -->
                                <div v-else-if="partido.ronda === 1">
                                  <div
                                    v-if="habilitarEdicionPredicciones"
                                    class="predicciones-editables"
                                  >
                                    <!-- Local - editable -->
                                    <v-card
                                      class="prediccion-editable mb-2"
                                      :class="{ bye: partido.local === null }"
                                      :draggable="
                                        habilitarEdicionPredicciones &&
                                        partido.local !== null
                                      "
                                      @dragstart="
                                        onPrediccionDragStart(
                                          $event,
                                          partido,
                                          'local',
                                        )
                                      "
                                      @dragover.prevent="
                                        onPrediccionDragOver($event)
                                      "
                                      @drop="
                                        onPrediccionDrop(
                                          $event,
                                          partido,
                                          'local',
                                        )
                                      "
                                      outlined
                                      flat
                                    >
                                      <v-card-text
                                        class="py-2 d-flex justify-space-between align-center"
                                      >
                                        <span class="prediccion-texto">
                                          {{ partido.local ?? "BYE" }}
                                        </span>
                                        <div>
                                          <v-chip
                                            v-if="partido.local === null"
                                            x-small
                                            color="green"
                                            class="bye-badge"
                                          >
                                            BYE
                                          </v-chip>
                                          <v-icon
                                            v-if="
                                              habilitarEdicionPredicciones &&
                                              partido.local !== null
                                            "
                                            small
                                            class="drag-indicator ml-1"
                                          >
                                            mdi-drag-vertical
                                          </v-icon>
                                        </div>
                                      </v-card-text>
                                    </v-card>

                                    <div class="vs-line text-center my-1">
                                      <v-chip x-small color="grey lighten-2"
                                        >VS</v-chip
                                      >
                                    </div>

                                    <!-- Visitante - editable -->
                                    <v-card
                                      class="prediccion-editable"
                                      :class="{
                                        bye: partido.visitante === null,
                                      }"
                                      :draggable="
                                        habilitarEdicionPredicciones &&
                                        partido.visitante !== null
                                      "
                                      @dragstart="
                                        onPrediccionDragStart(
                                          $event,
                                          partido,
                                          'visitante',
                                        )
                                      "
                                      @dragover.prevent="
                                        onPrediccionDragOver($event)
                                      "
                                      @drop="
                                        onPrediccionDrop(
                                          $event,
                                          partido,
                                          'visitante',
                                        )
                                      "
                                      outlined
                                      flat
                                    >
                                      <v-card-text
                                        class="py-2 d-flex justify-space-between align-center"
                                      >
                                        <span class="prediccion-texto">
                                          {{ partido.visitante ?? "BYE" }}
                                        </span>
                                        <div>
                                          <v-chip
                                            v-if="partido.visitante === null"
                                            x-small
                                            color="green"
                                            class="bye-badge"
                                          >
                                            BYE
                                          </v-chip>
                                          <v-icon
                                            v-if="
                                              habilitarEdicionPredicciones &&
                                              partido.visitante !== null
                                            "
                                            small
                                            class="drag-indicator ml-1"
                                          >
                                            mdi-drag-vertical
                                          </v-icon>
                                        </div>
                                      </v-card-text>
                                    </v-card>
                                  </div>

                                  <!-- Si no está en modo edición, mostrar normal -->
                                  <div v-else class="predicciones-normales">
                                    <v-card class="mb-2" outlined flat>
                                      <v-card-text
                                        class="py-2 d-flex align-center justify-space-between"
                                      >
                                        <!-- Nombre del equipo -->
                                        <span class="flex-grow-1 text-center">
                                          {{
                                            obtenerNombreEquipo(partido.local)
                                          }}
                                        </span>
                                      </v-card-text>
                                    </v-card>

                                    <div class="vs-line text-center my-1">
                                      <v-chip x-small color="grey lighten-2"
                                        >VS</v-chip
                                      >
                                    </div>

                                    <v-card outlined flat>
                                      <v-card-text
                                        class="py-2 d-flex align-center justify-space-between"
                                      >
                                        <!-- Nombre del equipo -->
                                        <span class="flex-grow-1 text-center">
                                          {{
                                            obtenerNombreEquipo(
                                              partido.visitante,
                                            )
                                          }}
                                        </span>
                                      </v-card-text>
                                    </v-card>
                                  </div>
                                </div>

                                <!-- CONDICIÓN 3: RONDAS 2+ -->
                                <div class="match-ronda-dos-mas" v-else>
                                  <!-- Equipo local -->
                                  <v-card class="mb-2" outlined flat>
                                    <v-card-text class="py-2">
                                      <div
                                        :class="[
                                          'equipo-linea-ronda2',
                                          {
                                            ganador:
                                              partido.ganador?.id ===
                                                partido.local?.id &&
                                              partido.local?.id,
                                          },
                                        ]"
                                      >
                                        <span
                                          v-if="
                                            partido.local &&
                                            typeof partido.local === 'object' &&
                                            !partido.local._temporal
                                          "
                                        >
                                          {{ partido.local.nombre }}
                                        </span>
                                        <span
                                          v-else-if="partido.dePartido?.[0]"
                                        >
                                          Ganador P{{ partido.dePartido[0] }}
                                        </span>
                                        <span v-else> — </span>

                                        <v-chip
                                          v-if="
                                            partido.local &&
                                            partido.ganador?.id ===
                                              partido.local?.id
                                          "
                                          x-small
                                          color="success"
                                          class="ml-2"
                                        >
                                          <v-icon x-small left
                                            >mdi-trophy</v-icon
                                          >
                                          Ganador
                                        </v-chip>
                                      </div>
                                    </v-card-text>
                                  </v-card>

                                  <div class="vs-line text-center my-1">
                                    <v-chip x-small color="grey lighten-2"
                                      >VS</v-chip
                                    >
                                  </div>

                                  <!-- Equipo visitante -->
                                  <v-card outlined flat>
                                    <v-card-text class="py-2">
                                      <div
                                        :class="[
                                          'equipo-linea-ronda2',
                                          {
                                            ganador:
                                              partido.ganador?.id ===
                                                partido.visitante?.id &&
                                              partido.visitante?.id,
                                          },
                                        ]"
                                      >
                                        <span
                                          v-if="
                                            partido.visitante &&
                                            typeof partido.visitante ===
                                              'object' &&
                                            !partido.visitante._temporal
                                          "
                                        >
                                          {{ partido.visitante.nombre }}
                                        </span>
                                        <span
                                          v-else-if="partido.dePartido?.[1]"
                                        >
                                          Ganador P{{ partido.dePartido[1] }}
                                        </span>
                                        <span v-else> — </span>

                                        <v-chip
                                          v-if="
                                            partido.visitante &&
                                            partido.ganador?.id ===
                                              partido.visitante?.id
                                          "
                                          x-small
                                          color="success"
                                          dark
                                          class="ml-2"
                                        >
                                          <v-icon x-small left
                                            >mdi-trophy</v-icon
                                          >
                                          Ganador
                                        </v-chip>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </div>

                                <!-- RESULTADO -->
                                <div
                                  v-if="partido.resultado"
                                  class="resultado mt-3"
                                >
                                  <v-chip
                                    color="blue-grey"
                                    dark
                                    small
                                    block
                                    class="text-center"
                                  >
                                    <v-icon small left>mdi-scoreboard</v-icon>
                                    {{ partido.resultado }}
                                  </v-chip>
                                </div>

                                <!-- OBSERVACIONES -->
                                <div
                                  v-if="partido.detalles?.observaciones"
                                  class="observaciones mt-2"
                                >
                                  <v-alert type="info" dense text class="py-1">
                                    <v-icon small left>mdi-note-text</v-icon>
                                    {{
                                      partido.detalles.observaciones.substring(
                                        0,
                                        50,
                                      )
                                    }}
                                    {{
                                      partido.detalles.observaciones.length > 50
                                        ? "..."
                                        : ""
                                    }}
                                  </v-alert>
                                </div>

                                <!-- BYE indicator -->
                                <div
                                  v-if="partido.pasaAutomatico"
                                  class="bye-indicator mt-2"
                                >
                                  <v-chip color="green" dark small block>
                                    <v-icon small left>mdi-fast-forward</v-icon>
                                    BYE -
                                    {{
                                      partido.ganador?.nombre || "Sin ganador"
                                    }}
                                  </v-chip>
                                </div>
                              </v-card-text>

                              <v-divider></v-divider>

                              <!-- BOTONES DE ACCIÓN -->
                              <v-card-actions class="pa-3 match-actions">
                                <v-btn
                                  @click="abrirModalDetalles(partido)"
                                  color="primary"
                                  small
                                  text
                                  dark
                                  :disabled="estadoTorneo === 'Finalizado'"
                                >
                                  <v-icon small left>mdi-information</v-icon>
                                  Detalles
                                </v-btn>

                                <v-spacer></v-spacer>

                                <!-- Solo mostrar RESULTADO si no hay ganador -->
                                <v-btn
                                  v-if="
                                    partido.local &&
                                    partido.visitante &&
                                    !partido.pasaAutomatico &&
                                    !partido.ganador
                                  "
                                  @click="
                                    abrirModalResultadoConAdvertencia(partido)
                                  "
                                  color="success"
                                  small
                                  :disabled="estadoTorneo === 'Finalizado'"
                                >
                                  <v-icon small left>mdi-soccer</v-icon>
                                  Resultado
                                </v-btn>

                                <!-- Solo mostrar EDITAR si hay ganador -->
                                <v-btn
                                  v-if="
                                    partido.local &&
                                    partido.visitante &&
                                    partido.ganador &&
                                    !partido.pasaAutomatico
                                  "
                                  @click="
                                    abrirModalResultadoConAdvertencia(partido)
                                  "
                                  color="warning"
                                  small
                                  :disabled="estadoTorneo === 'Finalizado'"
                                >
                                  <v-icon small left>mdi-pencil</v-icon>
                                  Editar
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </div>
                        </div>

                        <!-- CAMPEÓN -->
                        <div
                          v-if="campeon"
                          class="campeon-container"
                          :key="campeonKey"
                        >
                          <v-card
                            color="amber lighten-1"
                            class="text-center py-6"
                          >
                            <div class="campeon-trophy">
                              <v-icon x-large color="yellow darken-3"
                                >mdi-trophy</v-icon
                              >
                            </div>
                            <h2
                              class="campeon-titulo headline font-weight-bold mt-2"
                            >
                              ¡CAMPEÓN!
                            </h2>
                            <div
                              class="campeon-nombre display-1 font-weight-bold mt-2"
                            >
                              {{ campeon.nombre }}
                            </div>
                            <!-- <v-chip color="yellow darken-3" dark class="mt-3">
                              <v-icon left>mdi-crown</v-icon>
                              Ganador del Torneo
                            </v-chip> -->

                            <v-btn
                              v-if="estadoTorneo !== 'Finalizado'"
                              color="success"
                              large
                              class="mt-4"
                              @click="abrirModalFinalizar"
                            >
                              <v-icon left>mdi-flag-checkered</v-icon>
                              Finalizar Torneo
                            </v-btn>

                            <v-chip
                              v-else
                              color="success"
                              dark
                              large
                              class="mt-4"
                            >
                              <v-icon left>mdi-check-circle</v-icon>
                              Torneo Finalizado
                            </v-chip>
                          </v-card>
                        </div>

                        <svg
                          v-if="partidoRefsReady && curves.length > 0"
                          class="svg-conexiones"
                          :width="svgWidth"
                          :height="svgHeight"
                          :viewBox="`0 0 ${svgWidth} ${svgHeight}`"
                        >
                          <path
                            v-for="line in curves"
                            :key="line.id"
                            :d="line.d"
                            stroke="#4f46e5"
                            stroke-width="2"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            :opacity="0.7"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <v-alert v-else type="info" class="mt-4">
              <v-icon left>mdi-information</v-icon>
              Primero debe generar un torneo desde la pestaña "Configuración"
            </v-alert>
          </v-tab-item>
        </v-tabs-items>
        <v-btn dark color="#24232d" class="mt-8 mb-4" @click="volver">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-main>
    </div>

    <!-- MODALES (mantener igual) -->
    <editar-detalles-partido
      :visible="modalDetallesVisible"
      :partido="partidoActivo"
      :proxy="proxy"
      @close="closeModalDetalles"
      @save="guardarDetalles"
    />

    <cargar-resultado
      :partido="partidoActivo"
      :visible="modalResultadoVisible"
      :proxy="proxy"
      :deporte="deporte"
      @close="closeModalResultado"
      @save="guardarResultado"
    />

    <asignar-jugadores
      v-if="modalAsignarJugadoresVisible"
      :visible="modalAsignarJugadoresVisible"
      :tipo-competencia="tipoCompetenciaTorneo"
      :proxy="proxy"
      :id-torneo="idTorneo"
      :ids="equipoActivo?.ids"
      :ids-usados="equipoActivo?._idsUsados || []"
      :info-torneo="infoTorneo"
      sistema-competencia="Torneo"
      @close="modalAsignarJugadoresVisible = false"
      @save="asignarJugadoresAEquipoActivo"
    />

    <asignar-nombre-equipo
      v-if="modalAsignarNombreVisible"
      :visible="modalAsignarNombreVisible"
      :nombre-actual="equipoActivo?.nombre"
      @close="modalAsignarNombreVisible = false"
      @save="asignarNombreEquipoFutbol"
    />

    <modal-finalizar-competencia
      :visible="modalFinalizarVisible"
      :jugadores="jugadoresFinales"
      tipo-competencia="Torneo"
      :nombre-competencia="nombreTorneo"
      :categoria="categoriaTorneo"
      :genero="generoTorneo"
      @close="modalFinalizarVisible = false"
      @finalizar="finalizarTorneo"
    />
  </v-app>
</template>

<script lang="ts" setup>
import {
  ref,
  nextTick,
  computed,
  watch,
  onMounted,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import {
  generarTorneo,
  generarPartidosDeZona,
  generarCrucesConByes,
  calcularTablaZona,
  type EstrategiaByes,
} from "../../utils/torneos";
import CargarResultado from "./CargarResultado.vue";
import EditarDetallesPartido from "./EditarDetallesPartido.vue"; // NUEVO IMPORT
import TorneoContextBar from "./TorneoContextBar.vue";
import { showAlert, confirmModal } from "@/utils/toast";
import axios from "@/axios-auth";
import AsignarJugadores from "./AsignarJugadores.vue";
import AsignarNombreEquipo from "./AsignarNombreEquipo.vue";
import ModalFinalizarCompetencia from "./ModalFinalizarCompetencia.vue";
import {
  obtenerJugadoresOrdenadosTorneo,
  puedeFinalizarTorneo,
  type JugadorParaFinalizar,
} from "@/utils/rankings";
import { calcularGanador } from "@/utils/resultados";
import { getConfigDeporte } from "@/utils/deportes-config";

const total = ref(8);
const modalidad = ref<"eliminacion_directa" | "zonas_y_eliminacion">(
  "eliminacion_directa",
);
const clasificados = ref<number | undefined>(undefined);
const zonasDeseadas = ref<number | undefined>(undefined);
const estrategiaByes = ref<EstrategiaByes>("orden_zonas");
const nombreTorneo = ref("");
const categoriaTorneo = ref("");
const generoTorneo = ref("");
const tipoCompetenciaTorneo = ref("");
const idTorneo = ref();
const idInstitucion = ref();
const infoTorneo = ref("");
const deporte = ref<"Futbol" | "Padel" | "Tenis">("Padel");

const torneo = ref<any>(null);
const torneoOriginal = ref<any>(null);
const partidoRefs: Record<number, HTMLElement> = {};
const partidoRefsReady = ref(false);
const curves = ref<{ id: string; d: string }[]>([]);
const ignoreNextZonaChange = ref(false); // Nueva bandera

const tab = ref(0);
const zonaTabs = ref<Record<number, number>>({});
const zonaDragOver = ref<number | null>(null);

// Variables para draggable de equipos
const equipoDragging = ref<any>(null);
const partidoDragging = ref<any>(null);
const posicionDragging = ref<"local" | "visitante" | null>(null);
const partidosOriginalesRonda1 = ref<any[]>([]);

const partidosOriginalesPredicciones = ref<any[]>([]);
const partidosOriginalesEstructura = ref<any[]>([]);

const modalResultadoVisible = ref(false);
const modalAsignarJugadoresVisible = ref(false);
const modalAsignarNombreVisible = ref(false);

const partidoActivo = ref<any>(null);
const equipoActivo = ref(null);
const zonaActiva = ref(null);
const sets = ref<Array<{ local: number | null; visitante: number | null }>>([]);
const modalDetallesVisible = ref(false);

const rondasContainer = ref<HTMLElement | null>(null);
const svgWidth = ref(0);
const svgHeight = ref(0);
const calculandoCurvas = ref(false);
const ultimoCalculo = ref(0);

const guardarInterval = ref();

// Nueva variable para controlar edición de predicciones
const habilitarEdicionPredicciones = ref(false);

const modalidades = ref([
  { text: "Eliminación Directa", value: "eliminacion_directa" },
  { text: "Zonas + Eliminación", value: "zonas_y_eliminacion" },
]);

const estrategiasByes = ref([
  { text: "Orden de Zonas", value: "orden_zonas" },
  { text: "Mejor Clasificación", value: "mejor_clasificacion" },
]);

const campeonKey = ref(0);
const estadoKey = ref(0);

// Variables para el drag & drop de equipos entre zonas
const equipoDragData = ref<{
  equipo: any;
  zonaOrigen: any;
} | null>(null);

const estadoTorneo = ref("Draft");

const hayCambiosSinGuardar = ref(false);

const modalFinalizarVisible = ref(false);
const jugadoresFinales = ref<JugadorParaFinalizar[]>([]);

const { proxy } = getCurrentInstance();

const configDeporte = computed(() => getConfigDeporte(deporte.value));
const usaJugadores = computed(() => configDeporte.value.usaJugadores);

const headersPartidos = computed(() => {
  return [
    { text: "Partido", value: "id", sortable: false, width: "80px" },
    { text: "Local", value: "local", sortable: false, width: "25%" },
    { text: "VS", value: "vs", sortable: false },
    { text: "Visitante", value: "visitante", sortable: false, width: "25%" },
    { text: "Detalles", value: "detalles", sortable: false },
    { text: "Resultado", value: "resultado", sortable: false },
    { text: "Estado", value: "estado", sortable: false },
    { text: "Acciones", value: "actions", sortable: false },
  ];
});

// Variables para draggable de predicciones
const prediccionDragging = ref<{
  partido: any;
  posicion: "local" | "visitante";
  valor: string | null;
} | null>(null);

// Mapa para rastrear qué predicción va a qué equipo
const mapaPrediccionesEquipos = ref<Map<string, string>>(new Map());
// Ejemplo: "2º de zona 1" -> "local_P1" (significa que va como local en Partido 1)

function abrirModalDetalles(partido: any) {
  partidoActivo.value = partido;
  modalDetallesVisible.value = true;
}

function closeModalDetalles() {
  modalDetallesVisible.value = false;
  partidoActivo.value = null;
}

function guardarDetalles(detalles: any) {
  if (!partidoActivo.value) return;

  // Asegurar que el objeto detalles exista
  if (!partidoActivo.value.detalles) {
    partidoActivo.value.detalles = {};
  }

  // Actualizar detalles
  partidoActivo.value.detalles = {
    ...partidoActivo.value.detalles,
    ...detalles,
  };

  // Limpiar campos vacíos
  Object.keys(partidoActivo.value.detalles).forEach((key) => {
    if (!partidoActivo.value.detalles[key]) {
      delete partidoActivo.value.detalles[key];
    }
  });

  closeModalDetalles();
}

function reestablecerPrediccionesRondasSiguientes() {
  if (!torneo.value?.rondas || torneo.value.rondas.length <= 1) return;

  // Para cada ronda después de la primera
  for (let i = 1; i < torneo.value.rondas.length; i++) {
    const ronda = torneo.value.rondas[i];
    const rondaAnterior = torneo.value.rondas[i - 1];

    ronda.partidos.forEach((partido: any, index: number) => {
      // Resetear completamente si no tiene equipos reales
      if (
        !partido.local ||
        !partido.visitante ||
        (partido.local && partido.local._temporal) ||
        (partido.visitante && partido.visitante._temporal)
      ) {
        // Solo resetear si no hay equipos reales en ambos lados
        const tieneEquipoRealLocal =
          partido.local &&
          typeof partido.local === "object" &&
          !partido.local._temporal;
        const tieneEquipoRealVisitante =
          partido.visitante &&
          typeof partido.visitante === "object" &&
          !partido.visitante._temporal;

        if (!tieneEquipoRealLocal) {
          partido.local = null;
        }

        if (!tieneEquipoRealVisitante) {
          partido.visitante = null;
        }
      }

      // Mantener la referencia a los partidos de la ronda anterior
      const partidoAnteriorLocal = rondaAnterior.partidos[index * 2];
      const partidoAnteriorVisitante = rondaAnterior.partidos[index * 2 + 1];

      // Establecer referencias
      partido.dePartido = [
        partidoAnteriorLocal?.id,
        partidoAnteriorVisitante?.id,
      ].filter(Boolean);

      // Establecer nombres predictivos solo si no hay equipo real
      if (!partido.local && partidoAnteriorLocal) {
        partido.local = {
          nombre: `Ganador P${partidoAnteriorLocal.id}`,
          // ⭐ SIN flag _temporal
        };
      }

      if (!partido.visitante && partidoAnteriorVisitante) {
        partido.visitante = {
          nombre: `Ganador P${partidoAnteriorVisitante.id}`,
          // ⭐ SIN flag _temporal
        };
      }
    });
  }

  // Forzar actualización de campeón
  campeonKey.value++;
}

// Función para limpiar todos los flags _temporal
function limpiarFlagsTemporales() {
  if (!torneo.value?.rondas) return;

  torneo.value.rondas.forEach((ronda: any) => {
    ronda.partidos.forEach((partido: any) => {
      if (partido.local && partido.local._temporal) {
        delete partido.local._temporal;
      }
      if (partido.visitante && partido.visitante._temporal) {
        delete partido.visitante._temporal;
      }
    });
  });
}

// Función para mover equipo entre zonas
async function moverEquipoEntreZonas(
  zonaOrigen: any,
  zonaDestino: any,
  equipo: any,
) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para mover los equipos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden mover los equipos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  // Verificar si ya hay resultados en fase eliminatoria
  if (hayResultadosEnFaseEliminacion()) {
    showAlert({
      icon: "warning",
      title:
        "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara mover equipos entre zonas, primero debe restaurar los cruces usando el botón '↺ Restaurar Cruces Guardados'.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (todosResultadosZonas.value) {
    showAlert({
      icon: "warning",
      title: "Ya se jugaron todos los partidos de zona.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  // Verificar cantidad mínima de equipos
  if (zonaOrigen.equipos.length <= 2) {
    showAlert({
      icon: "warning",
      title: `No se puede mover. La ${zonaOrigen.nombre} necesita al menos 2 equipos.`,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Mover equipo.",
    text: "¿Está seguro que desea mover el equipo? Se regenerarán los partidos.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  console.log(
    `Moviendo ${equipo.nombre} de ${zonaOrigen.nombre} a ${zonaDestino.nombre}`,
  );

  // 1. Remover de zona origen
  const equipoIndex = zonaOrigen.equipos.findIndex(
    (e: any) => e.id === equipo.id,
  );
  if (equipoIndex !== -1) {
    zonaOrigen.equipos.splice(equipoIndex, 1);
  }

  // 2. Agregar a zona destino (al final)
  zonaDestino.equipos.push({
    ...equipo,
    // Podrías querer regenerar IDs o mantener el mismo
  });

  // 3. Regenerar partidos en AMBAS zonas
  regenerarPartidosDeZona(zonaOrigen);
  regenerarPartidosDeZona(zonaDestino);
  showAlert({
    icon: "success",
    title: `Equipo "${equipo.nombre}" movido de ${zonaOrigen.nombre} a ${zonaDestino.nombre}.`,
    timer: 2500,
    vm: proxy,
  });
}

// Función para regenerar partidos de una zona
function regenerarPartidosDeZona(zona: any) {
  // Eliminar partidos existentes
  zona.partidos = [];

  // Generar nuevos partidos solo si hay al menos 2 equipos
  if (zona.equipos.length >= 2) {
    zona.partidos = generarPartidosDeZona(zona.equipos, deporte.value);

    // Reasignar IDs
    zona.partidos.forEach((partido: any, index: number) => {
      partido.id = `Z${zona.id}P${index + 1}`;
    });
  }
}

// Función para iniciar drag de predicción
function onPrediccionDragStart(
  event: DragEvent,
  partido: any,
  posicion: "local" | "visitante",
) {
  if (!habilitarEdicionPredicciones.value) {
    event.preventDefault();
    return;
  }

  const valor = posicion === "local" ? partido.local : partido.visitante;
  if (valor === null) return; // No arrastrar BYEs

  prediccionDragging.value = {
    partido,
    posicion,
    valor,
  };

  if (event.dataTransfer) {
    event.dataTransfer.setData("text/plain", valor);
    event.dataTransfer.effectAllowed = "move";
  }
}

function onPrediccionDragOver(event: DragEvent) {
  if (!habilitarEdicionPredicciones.value) return;
  event.preventDefault();
  if (event.dataTransfer) {
    event.dataTransfer.dropEffect = "move";
  }
}

function onPrediccionDrop(
  event: DragEvent,
  partidoDestino: any,
  posicionDestino: "local" | "visitante",
) {
  if (!habilitarEdicionPredicciones.value || !prediccionDragging.value) {
    event.preventDefault();
    return;
  }

  event.preventDefault();

  const {
    partido: partidoOrigen,
    posicion: posicionOrigen,
    valor: valorOrigen,
  } = prediccionDragging.value;

  // No hacer nada si es el mismo lugar
  if (
    partidoOrigen.id === partidoDestino.id &&
    posicionOrigen === posicionDestino
  ) {
    resetPrediccionDrag();
    return;
  }

  // Obtener valor destino
  const valorDestino =
    posicionDestino === "local"
      ? partidoDestino.local
      : partidoDestino.visitante;

  // Si el destino es un BYE (null), no permitir intercambiar
  if (valorDestino === null) {
    showAlert({
      icon: "warning",
      title: "No se puede mover una predicción a una posición con BYE.",
      timer: 4000,
      vm: proxy,
    });
    resetPrediccionDrag();
    return;
  }

  // Realizar intercambio
  intercambiarPredicciones(
    partidoOrigen,
    posicionOrigen,
    partidoDestino,
    posicionDestino,
  );

  // Guardar el mapeo para cuando se asignen equipos reales
  guardarMapeoPredicciones();

  resetPrediccionDrag();
}

// Función para intercambiar predicciones
function intercambiarPredicciones(
  partidoA: any,
  posicionA: "local" | "visitante",
  partidoB: any,
  posicionB: "local" | "visitante",
) {
  const valorA = posicionA === "local" ? partidoA.local : partidoA.visitante;
  const valorB = posicionB === "local" ? partidoB.local : partidoB.visitante;

  console.log(`Intercambiando predicciones:
    ${valorA} (P${partidoA.id}, ${posicionA}) ↔
    ${valorB} (P${partidoB.id}, ${posicionB})`);

  // Intercambiar valores
  if (posicionA === "local") {
    partidoA.local = valorB;
  } else {
    partidoA.visitante = valorB;
  }

  if (posicionB === "local") {
    partidoB.local = valorA;
  } else {
    partidoB.visitante = valorA;
  }

  // Actualizar BYEs si es necesario
  actualizarByesDespuesIntercambio(partidoA);
  actualizarByesDespuesIntercambio(partidoB);

  // Recalcular conexiones
  nextTick(() => {
    calcularCurvas();
  });
}

function actualizarByesDespuesIntercambio(partido: any) {
  partido.pasaAutomatico = partido.local === null || partido.visitante === null;
}

function resetPrediccionDrag() {
  prediccionDragging.value = null;
}

// Guardar mapeo de predicciones a posiciones
function guardarMapeoPredicciones() {
  if (!torneo.value?.rondas[0]?.partidos) return;

  mapaPrediccionesEquipos.value.clear();

  torneo.value.rondas[0].partidos.forEach((partido: any) => {
    if (partido.local && typeof partido.local === "string") {
      const clave = `${partido.local}`;
      const valor = `local_P${partido.id}`;
      mapaPrediccionesEquipos.value.set(clave, valor);
    }

    if (partido.visitante && typeof partido.visitante === "string") {
      const clave = `${partido.visitante}`;
      const valor = `visitante_P${partido.id}`;
      mapaPrediccionesEquipos.value.set(clave, valor);
    }
  });

  console.log(
    "Mapeo de predicciones guardado:",
    Array.from(mapaPrediccionesEquipos.value.entries()),
  );
}

// Nueva función para asignar equipos respetando el mapeo
async function asignarEquiposConMapeo(
  ronda1: any,
  clasificados: any[],
  encontrarEquipo: Function,
) {
  console.log("=== ASIGNANDO EQUIPOS CON MAPEO GUARDADO ===");
  console.log("Clasificados disponibles:", clasificados.length);

  // 1. Primero, resetear todos los partidos de ronda 1
  ronda1.partidos.forEach((partido: any) => {
    partido.local = null;
    partido.visitante = null;
    partido.ganador = null;
    partido.resultado = "";
    partido.pasaAutomatico = false;
    // Inicializar sets vacíos
    if (!partido.sets || partido.sets.length === 0) {
      const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
      partido.sets = Array.from({ length: minimosRequeridos }, () => ({
        gamesLocal: null,
        gamesVisitante: null,
      }));
    }
  });

  // 2. Crear un mapa inverso: posición → identificador
  const mapaPosiciones = new Map<string, string>();
  Array.from(mapaPrediccionesEquipos.value.entries()).forEach(
    ([identificador, posicion]) => {
      mapaPosiciones.set(posicion, identificador);
    },
  );

  console.log("Mapa de posiciones:", Array.from(mapaPosiciones.entries()));

  // 3. Recorrer todos los partidos y asignar según el mapeo
  let asignacionesExitosas = 0;
  let asignacionesFallidas = 0;

  ronda1.partidos.forEach((partido: any) => {
    const claveLocal = `local_P${partido.id}`;
    const claveVisitante = `visitante_P${partido.id}`;

    const identificadorLocal = mapaPosiciones.get(claveLocal);
    const identificadorVisitante = mapaPosiciones.get(claveVisitante);

    console.log(`Procesando partido P${partido.id}:`);
    console.log(
      `  - Clave local: ${claveLocal}, Identificador: ${identificadorLocal}`,
    );
    console.log(
      `  - Clave visitante: ${claveVisitante}, Identificador: ${identificadorVisitante}`,
    );

    // Buscar equipos para estos identificadores usando la función encontrarEquipo
    if (identificadorLocal) {
      const equipoLocal = encontrarEquipo(identificadorLocal);
      if (equipoLocal) {
        partido.local = equipoLocal;
        asignacionesExitosas++;
        console.log(
          `✓ Asignado local P${partido.id}: ${identificadorLocal} → ${equipoLocal.nombre}`,
        );
      } else {
        asignacionesFallidas++;
        console.warn(
          `✗ No se encontró equipo para: ${identificadorLocal} (local P${partido.id})`,
        );
        // Intentar buscar en los clasificados directamente
        const equipoEnClasificados = buscarEquipoEnClasificados(
          identificadorLocal,
          clasificados,
        );
        if (equipoEnClasificados) {
          partido.local = equipoEnClasificados;
          console.log(
            `  ✓ Encontrado en clasificados directos: ${equipoEnClasificados.nombre}`,
          );
          asignacionesExitosas++;
          asignacionesFallidas--;
        }
      }
    }

    if (identificadorVisitante) {
      const equipoVisitante = encontrarEquipo(identificadorVisitante);
      if (equipoVisitante) {
        partido.visitante = equipoVisitante;
        asignacionesExitosas++;
        console.log(
          `✓ Asignado visitante P${partido.id}: ${identificadorVisitante} → ${equipoVisitante.nombre}`,
        );
      } else {
        asignacionesFallidas++;
        console.warn(
          `✗ No se encontró equipo para: ${identificadorVisitante} (visitante P${partido.id})`,
        );
        // Intentar buscar en los clasificados directamente
        const equipoEnClasificados = buscarEquipoEnClasificados(
          identificadorVisitante,
          clasificados,
        );
        if (equipoEnClasificados) {
          partido.visitante = equipoEnClasificados;
          console.log(
            `  ✓ Encontrado en clasificados directos: ${equipoEnClasificados.nombre}`,
          );
          asignacionesExitosas++;
          asignacionesFallidas--;
        }
      }
    }

    // Actualizar estado de BYE (solo si hay exactamente un equipo)
    partido.pasaAutomatico =
      (partido.local && !partido.visitante) ||
      (!partido.local && partido.visitante);

    // Si es BYE, asignar ganador automático
    if (partido.pasaAutomatico) {
      if (partido.local && !partido.visitante) {
        partido.ganador = partido.local;
        partido.resultado = `BYE (avanza ${partido.local.nombre})`;
        actualizarSiguienteRonda(partido);
      } else if (!partido.local && partido.visitante) {
        partido.ganador = partido.visitante;
        partido.resultado = `BYE (avanza ${partido.visitante.nombre})`;
        actualizarSiguienteRonda(partido);
      }
    }

    console.log(
      `  Resultado final: ${partido.local?.nombre || "—"} vs ${
        partido.visitante?.nombre || "—"
      }`,
    );
  });

  console.log(`=== FIN ASIGNACIÓN CON MAPEO ===`);
  console.log(
    `Asignaciones exitosas: ${asignacionesExitosas}, Fallidas: ${asignacionesFallidas}`,
  );
}

// Función auxiliar para buscar equipo en clasificados directamente
function buscarEquipoEnClasificados(
  identificador: string,
  clasificados: any[],
) {
  // Intentar diferentes patrones
  const patrones = [
    /(\d+)º de zona (\d+)/,
    /(\d+)º mejor de zona (\d+)/,
    /Mejor (\d+)º/,
    /(\d+)º mejor (\d+)º/,
  ];

  for (const patron of patrones) {
    const match = identificador.match(patron);
    if (match) {
      if (patron.toString().includes("zona")) {
        // Patrón con zona
        const nivel = parseInt(match[1]);
        const zona = parseInt(match[2]);

        return clasificados.find(
          (c: any) =>
            c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
        );
      } else if (patron.toString().includes("Mejor")) {
        // Patrón de "Mejor Xº"
        const nivel = parseInt(match[1] || "2"); // Default a 2 si no hay número

        // Buscar el mejor equipo de ese nivel
        const equiposNivel = clasificados
          .filter((c: any) => c._meta && c._meta.nivel === nivel)
          .sort((a: any, b: any) => {
            if (b._meta.puntos !== a._meta.puntos)
              return b._meta.puntos - a._meta.puntos;
            if (b._meta.setsDiff !== a._meta.setsDiff)
              return b._meta.setsDiff - a._meta.setsDiff;
            return b._meta.gamesDiff - a._meta.gamesDiff;
          });

        return equiposNivel.length > 0 ? equiposNivel[0] : null;
      }
    }
  }

  return null;
}

// Función original de asignación (para cuando no hay mapeo)
async function asignarEquiposOriginal(
  ronda1: any,
  clasificados: any[],
  prediccionOriginal: any,
  encontrarEquipo: Function,
) {
  console.log("=== ASIGNANDO EQUIPOS CON PREDICCIÓN ORIGINAL ===");
  console.log("Clasificados disponibles:", clasificados.length);
  console.log("Predicción original:", prediccionOriginal);

  const mapaEquipos = new Map<string, any>();
  const identificadoresUnicos: string[] = [];

  // Extraer todos los identificadores únicos de la predicción
  prediccionOriginal.enfrentamientos.forEach((partido: any) => {
    if (
      partido.local &&
      typeof partido.local === "string" &&
      !mapaEquipos.has(partido.local)
    ) {
      identificadoresUnicos.push(partido.local);
    }
    if (
      partido.visitante &&
      typeof partido.visitante === "string" &&
      !mapaEquipos.has(partido.visitante)
    ) {
      identificadoresUnicos.push(partido.visitante);
    }
  });

  console.log("Identificadores a mapear:", identificadoresUnicos);

  // Mapear cada identificador a un equipo real
  identificadoresUnicos.forEach((identificador) => {
    const equipo = encontrarEquipo(identificador);
    if (equipo) {
      mapaEquipos.set(identificador, equipo);
      console.log(`✓ Mapeado: "${identificador}" -> ${equipo.nombre}`);
    } else {
      console.warn(`✗ No se encontró equipo para: "${identificador}"`);
      // Intentar buscar directamente en clasificados
      const equipoDirecto = buscarEquipoEnClasificados(
        identificador,
        clasificados,
      );
      if (equipoDirecto) {
        mapaEquipos.set(identificador, equipoDirecto);
        console.log(`  ✓ Encontrado directamente: ${equipoDirecto.nombre}`);
      }
    }
  });

  // Resetear partidos
  ronda1.partidos.forEach((partido: any) => {
    partido.local = null;
    partido.visitante = null;
    partido.ganador = null;
    partido.resultado = "";
    partido.pasaAutomatico = false;
    // Inicializar sets vacíos
    if (!partido.sets || partido.sets.length === 0) {
      const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
      partido.sets = Array.from({ length: minimosRequeridos }, () => ({
        gamesLocal: null,
        gamesVisitante: null,
      }));
    }
  });

  // Asignar según predicción
  let asignacionesExitosas = 0;
  let asignacionesFallidas = 0;

  prediccionOriginal.enfrentamientos.forEach(
    (partidoPredicho: any, index: number) => {
      const partidoReal = ronda1.partidos[index];
      if (!partidoReal) return;

      // Buscar equipos reales en el mapa
      const localReal = partidoPredicho.local
        ? mapaEquipos.get(partidoPredicho.local as string) || null
        : null;
      const visitanteReal = partidoPredicho.visitante
        ? mapaEquipos.get(partidoPredicho.visitante as string) || null
        : null;

      // Solo asignar si encontramos equipos
      if (localReal && typeof localReal === "object") {
        partidoReal.local = localReal;
        asignacionesExitosas++;
      }
      if (visitanteReal && typeof visitanteReal === "object") {
        partidoReal.visitante = visitanteReal;
        asignacionesExitosas++;
      }

      partidoReal.pasaAutomatico = partidoPredicho.pasaAutomatico;

      console.log(
        `Partido ${index + 1}: ${
          localReal?.nombre || partidoPredicho.local || "—"
        } vs ${visitanteReal?.nombre || partidoPredicho.visitante || "—"} ${
          partidoReal.pasaAutomatico ? "(BYE)" : ""
        }`,
      );

      // Contar asignaciones fallidas
      if (
        partidoPredicho.local &&
        typeof partidoPredicho.local === "string" &&
        !localReal
      ) {
        asignacionesFallidas++;
        console.warn(`  ✗ No se pudo asignar: ${partidoPredicho.local}`);
      }
      if (
        partidoPredicho.visitante &&
        typeof partidoPredicho.visitante === "string" &&
        !visitanteReal
      ) {
        asignacionesFallidas++;
        console.warn(`  ✗ No se pudo asignar: ${partidoPredicho.visitante}`);
      }

      // BYEs automáticos
      if (partidoReal.pasaAutomatico) {
        if (localReal && !visitanteReal) {
          partidoReal.ganador = localReal;
          partidoReal.resultado = `BYE (avanza ${localReal.nombre})`;
          actualizarSiguienteRonda(partidoReal);
        } else if (!localReal && visitanteReal) {
          partidoReal.ganador = visitanteReal;
          partidoReal.resultado = `BYE (avanza ${visitanteReal.nombre})`;
          actualizarSiguienteRonda(partidoReal);
        }
      }
    },
  );

  console.log("=== FIN ASIGNACIÓN ORIGINAL ===");
  console.log(
    `Asignaciones exitosas: ${asignacionesExitosas}, Fallidas: ${asignacionesFallidas}`,
  );
}

// Guardar mapeo cuando se generan los cruces iniciales
watch(
  () => torneo.value?.rondas?.[0]?.partidos,
  (nuevosPartidos) => {
    if (nuevosPartidos && !todosResultadosZonas.value) {
      // Guardar mapeo inicial
      guardarMapeoPredicciones();
    }
  },
  { deep: true },
);

// También guardar mapeo cuando se editan predicciones
watch(
  () => habilitarEdicionPredicciones.value,
  (editando) => {
    if (!editando) {
      // Al salir del modo edición, guardar el mapeo final
      guardarMapeoPredicciones();
    }
  },
);

function onEquipoDragStart(
  event: DragEvent,
  equipo: any,
  partido: any,
  posicion: "local" | "visitante",
) {
  if (!equipo || partido.ganador || partido.pasaAutomatico) {
    event.preventDefault();
    return;
  }

  equipoDragging.value = equipo;
  partidoDragging.value = partido;
  posicionDragging.value = posicion;

  if (event.dataTransfer) {
    event.dataTransfer.setData("text/plain", equipo.id);
    event.dataTransfer.effectAllowed = "move";
  }
}

// Función cuando empieza a arrastrar un equipo DESDE UNA ZONA
function onEquipoDragStartZona(event: DragEvent, equipo: any, zonaOrigen: any) {
  equipoDragData.value = {
    equipo,
    zonaOrigen,
    origen: "zona", // ← IMPORTANTE: identificar que viene de una zona
  };

  if (event.dataTransfer) {
    event.dataTransfer.setData("text/plain", `zona-${equipo.id}`);
    event.dataTransfer.effectAllowed = "move";
  }

  // Feedback visual
  const target = event.target as HTMLElement;
  target.classList.add("dragging");
}

// Función cuando un equipo se arrastra sobre una zona
function onZonaDragOver(event: DragEvent) {
  event.preventDefault();
  if (event.dataTransfer) {
    event.dataTransfer.dropEffect = "move";
  }

  // Feedback visual
  const target = event.currentTarget as HTMLElement;
  target.classList.add("drag-over-zone");
}

function onZonaDragLeave(event: DragEvent) {
  const target = event.currentTarget as HTMLElement;
  target.classList.remove("drag-over-zone");
}

// Función cuando se suelta un equipo en una zona
function onZonaDrop(event: DragEvent, zonaDestino: any) {
  event.preventDefault();

  if (!equipoDragData.value || equipoDragData.value.origen !== "zona") {
    limpiarFeedbackDrag();
    return;
  }

  const { equipo, zonaOrigen } = equipoDragData.value;

  // Limpiar feedback visual
  limpiarFeedbackDrag();

  // Evitar mover a la misma zona
  if (zonaOrigen.id === zonaDestino.id) {
    equipoDragData.value = null;
    return;
  }

  // Mover equipo de zona origen a zona destino
  moverEquipoEntreZonas(zonaOrigen, zonaDestino, equipo);

  equipoDragData.value = null;
}

// Función para limpiar feedback visual
function limpiarFeedbackDrag() {
  document.querySelectorAll(".dragging, .drag-over-zone").forEach((el) => {
    el.classList.remove("dragging", "drag-over-zone");
  });
}

// Función cuando termina el drag
function onEquipoDragEnd() {
  limpiarFeedbackDrag();
  equipoDragData.value = null;
}

function onEquipoDragOver(event: DragEvent) {
  event.preventDefault();
  if (event.dataTransfer) {
    event.dataTransfer.dropEffect = "move";
  }

  // Agregar clase visual para feedback
  const target = event.target as HTMLElement;
  if (target.classList.contains("equipo-draggable")) {
    target.classList.add("drag-over");
  }
}

function onEquipoDragLeave(event: DragEvent) {
  const target = event.target as HTMLElement;
  if (target.classList.contains("equipo-draggable")) {
    target.classList.remove("drag-over");
  }
}

function onEquipoDrop(
  event: DragEvent,
  partidoDestino: any,
  posicionDestino: "local" | "visitante",
) {
  event.preventDefault();

  // Limpiar clases visuales
  const target = event.target as HTMLElement;
  if (target.classList.contains("equipo-draggable")) {
    target.classList.remove("drag-over");
  }

  // Validaciones
  if (!equipoDragging.value || !partidoDragging.value) {
    resetDragData();
    return;
  }

  // No intercambiar con el mismo partido/posición
  if (
    partidoDragging.value.id === partidoDestino.id &&
    posicionDragging.value === posicionDestino
  ) {
    resetDragData();
    return;
  }

  // Obtener equipo destino
  const equipoDestino =
    posicionDestino === "local"
      ? partidoDestino.local
      : partidoDestino.visitante;

  // Realizar intercambio
  intercambiarEquipos(
    partidoDragging.value,
    posicionDragging.value!,
    equipoDragging.value,
    partidoDestino,
    posicionDestino,
    equipoDestino,
  );

  if (
    partidoDragging.value.ganador ||
    partidoDragging.value.pasaAutomatico ||
    partidoDestino.ganador ||
    partidoDestino.pasaAutomatico
  ) {
    console.log("partidos", partidoDestino, partidoDragging);
    actualizarSiguienteRonda({
      ...partidoDestino,
      ganador: partidoDestino.local,
    });
  }

  resetDragData();
}

function intercambiarEquipos(
  partidoA: any,
  posicionA: "local" | "visitante",
  equipoA: any,
  partidoB: any,
  posicionB: "local" | "visitante",
  equipoB: any,
) {
  console.log(`Intercambiando:
    Partido ${partidoA.id} (${posicionA}): ${equipoA?.nombre}
    Partido ${partidoB.id} (${posicionB}): ${equipoB?.nombre || "Vacío"}`);

  // Guardar posiciones originales para animación
  const posOriginalA = {
    x: partidoRefs[partidoA.id]?.offsetLeft || 0,
    y: partidoRefs[partidoA.id]?.offsetTop || 0,
  };

  const posOriginalB = {
    x: partidoRefs[partidoB.id]?.offsetLeft || 0,
    y: partidoRefs[partidoB.id]?.offsetTop || 0,
  };

  // Realizar intercambio
  if (posicionA === "local") {
    partidoA.local = equipoB;
  } else {
    partidoA.visitante = equipoB;
  }

  if (posicionB === "local") {
    partidoB.local = equipoA;
  } else {
    partidoB.visitante = equipoA;
  }

  // Limpiar resultados de ambos partidos
  limpiarResultadoPartido(partidoA);
  limpiarResultadoPartido(partidoB);

  console.log("Intercambio completado");

  // ⚡ FORZAR actualización del DOM y recalcular conexiones
  recalcularTodasLasConexiones();
}

async function toggleEdicionPredicciones() {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para editar los cruces.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }
  const estabaEditando = habilitarEdicionPredicciones.value;
  habilitarEdicionPredicciones.value = !habilitarEdicionPredicciones.value;

  // Si ESTÁBAMOS editando y ahora FINALIZAMOS
  if (estabaEditando) {
    console.log("🔚 Finalizando edición, reasignando refs...");

    // 1. Guardar el mapeo de predicciones
    guardarMapeoPredicciones();

    // 2. Forzar actualización del DOM
    await nextTick();

    // 3. Resetear y reasignar TODOS los refs
    await resetearYReasignarRefs();

    // 4. Recalcular conexiones
    recalcularTodasLasConexiones();

    console.log("✅ Edición finalizada, refs reasignados");
  }
}

// NUEVA FUNCIÓN: Resetear y reasignar refs
async function resetearYReasignarRefs() {
  // 1. Limpiar todos los refs existentes
  Object.keys(partidoRefs).forEach((key: any) => {
    delete partidoRefs[key];
  });

  // 2. Esperar a que Vue actualice el DOM
  await nextTick();
  await new Promise((resolve) => setTimeout(resolve, 100)); // Delay extra

  // 3. Marcar que los refs no están listos
  partidoRefsReady.value = false;

  // 4. Forzar un nuevo ciclo de renderizado
  await nextTick();
  await nextTick(); // Doble nextTick para asegurar

  // 5. Los refs se reasignarán automáticamente en el template
  partidoRefsReady.value = true;
}

// NUEVA FUNCIÓN: Recalcular todas las conexiones
function recalcularTodasLasConexiones() {
  // Esperar a que Vue actualice el DOM
  nextTick(() => {
    // Pequeño delay para asegurar que el DOM esté actualizado
    setTimeout(() => {
      calcularCurvas();
      partidoRefsReady.value = true;
    }, 100);
  });
}

function limpiarResultadoPartido(partido: any) {
  partido.ganador = null;
  partido.resultado = "";

  // ✅ CREAR ESTRUCTURA CORRECTA SEGÚN DEPORTE
  const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;

  if (!partido.sets || partido.sets.length === 0) {
    partido.sets = Array.from({ length: minimosRequeridos }, () => ({
      gamesLocal: null,
      gamesVisitante: null,
    }));
  } else {
    // Ajustar cantidad de sets si es necesario
    if (partido.sets.length !== minimosRequeridos) {
      partido.sets = Array.from({ length: minimosRequeridos }, () => ({
        gamesLocal: null,
        gamesVisitante: null,
      }));
    } else {
      // Solo limpiar los valores, mantener la cantidad
      partido.sets.forEach((set: any) => {
        set.gamesLocal = null;
        set.gamesVisitante = null;
      });
    }
  }
}

function resetDragData() {
  equipoDragging.value = null;
  partidoDragging.value = null;
  posicionDragging.value = null;
}

// Función para obtener posición del equipo
function obtenerPosicionEquipo(equipo: any): string {
  if (!equipo?._meta) return "";
  return `${equipo._meta.nivel}º Z${equipo._meta.zona}`;
}

async function resetearCruces() {
  // Si no hay partidos originales guardados, intentar usar los actuales
  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden resetear los cruces.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (partidosOriginalesRonda1.value.length === 0) {
    if (torneo.value?.rondas?.[0]?.partidos) {
      // Guardar los partidos actuales como originales (pero sin resultados)
      partidosOriginalesRonda1.value = JSON.parse(
        JSON.stringify(torneo.value.rondas[0].partidos),
      ).map((partido: any) => ({
        id: partido.id,
        local: partido.local,
        visitante: partido.visitante,
        pasaAutomatico: partido.pasaAutomatico || false,
        // No guardamos ganador, resultado ni sets
      }));
      console.log(
        "Partidos actuales guardados como originales (sin resultados)",
      );
    } else {
      showAlert({
        icon: "warning",
        title: "No hay configuración de cruces disponible.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }
  }

  // Obtener clasificados actuales
  const clasificados = obtenerClasificados();

  if (clasificados.length === 0) {
    showAlert({
      icon: "warning",
      title:
        "No hay equipos clasificados disponibles. Primero cargue resultados de zonas.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Restaurar cruces.",
    text: "¿Está seguro que desea restaurar los cruces? Se regenerarán los partidos de la fase de eliminación.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  console.log("Clasificados disponibles para resetear:", clasificados.length);
  console.log("Tamaño mapa predicciones:", mapaPrediccionesEquipos.value.size);

  // **PASO CRÍTICO: LIMPIAR COMPLETAMENTE TODAS LAS RONDAS**
  console.log("Limpiando resultados de TODAS las rondas...");

  // Limpiar todas las rondas
  torneo.value.rondas.forEach((ronda: any, rondaIndex: number) => {
    console.log(`Limpiando ronda ${rondaIndex + 1}...`);

    ronda.partidos.forEach((partido: any) => {
      // Resetear completamente los resultados
      partido.ganador = null;
      partido.resultado = "";

      // Resetear sets
      if (!partido.sets || partido.sets.length === 0) {
        // ✅ CREAR SETS DINÁMICAMENTE SEGÚN DEPORTE
        const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
        partido.sets = Array.from({ length: minimosRequeridos }, () => ({
          gamesLocal: null,
          gamesVisitante: null,
        }));
      } else {
        partido.sets.forEach((set: any) => {
          set.gamesLocal = null;
          set.gamesVisitante = null;
        });
      }

      // **SOLO PARA RONDAS DESPUÉS DE LA PRIMERA: Resetear también los equipos**
      if (rondaIndex > 0) {
        partido.local = null;
        partido.visitante = null;

        // **IMPORTANTE: Mantener las referencias dePartido para reconstrucción**
        // Las referencias dePartido (localPartido, visitantePartido) deben mantenerse
        // para que el sistema sepa cómo reconstruir los enfrentamientos
      }
    });
  });

  // DECISIÓN CRÍTICA: ¿Qué restaurar?
  // Opción A: Si hay ediciones en el mapa, usarlas
  // Opción B: Si no hay ediciones, usar los originales

  const ronda1 = torneo.value.rondas[0];

  if (mapaPrediccionesEquipos.value.size > 0) {
    console.log("Restaurando usando MAPA DE PREDICCIONES EDITADO");
    // USAR LAS PREDICCIONES EDITADAS

    // **CORRECIÓN: Primero limpiar completamente los equipos de la ronda 1**
    ronda1.partidos.forEach((partido: any) => {
      partido.local = null;
      partido.visitante = null;
      partido.pasaAutomatico = false;
    });

    // Ahora asignar usando el mapa de predicciones EDITADO
    // 1. Crear mapa inverso: posición → identificador
    const mapaPosiciones = new Map<string, string>();
    Array.from(mapaPrediccionesEquipos.value.entries()).forEach(
      ([identificador, posicion]) => {
        mapaPosiciones.set(posicion, identificador);
      },
    );

    console.log(
      "Mapa de posiciones editado:",
      Array.from(mapaPosiciones.entries()),
    );

    // Función para encontrar equipo
    const encontrarEquipo = (identificador: string) => {
      if (!identificador || typeof identificador !== "string") return null;

      // Patrones comunes
      const matchZona = identificador.match(/(\d+)º de zona (\d+)/);
      if (matchZona) {
        const nivel = parseInt(matchZona[1]);
        const zona = parseInt(matchZona[2]);

        return clasificados.find(
          (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
        );
      }

      const matchMejorDeZona = identificador.match(
        /(\d+)º mejor de zona (\d+)/,
      );
      if (matchMejorDeZona) {
        const nivel = parseInt(matchMejorDeZona[1]);
        const zona = parseInt(matchMejorDeZona[2]);

        return clasificados.find(
          (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
        );
      }

      return buscarEquipoEnClasificados(identificador, clasificados);
    };

    // 2. Asignar equipos según el mapa EDITADO
    ronda1.partidos.forEach((partido: any) => {
      const claveLocal = `local_P${partido.id}`;
      const claveVisitante = `visitante_P${partido.id}`;

      const identificadorLocal = mapaPosiciones.get(claveLocal);
      const identificadorVisitante = mapaPosiciones.get(claveVisitante);

      if (identificadorLocal) {
        const equipoLocal = encontrarEquipo(identificadorLocal);
        if (equipoLocal) {
          partido.local = equipoLocal;
          console.log(
            `✓ Asignado local P${partido.id}: ${identificadorLocal} → ${equipoLocal.nombre}`,
          );
        } else {
          console.warn(
            `✗ No se encontró equipo para: ${identificadorLocal} (local P${partido.id})`,
          );
        }
      }

      if (identificadorVisitante) {
        const equipoVisitante = encontrarEquipo(identificadorVisitante);
        if (equipoVisitante) {
          partido.visitante = equipoVisitante;
          console.log(
            `✓ Asignado visitante P${partido.id}: ${identificadorVisitante} → ${equipoVisitante.nombre}`,
          );
        } else {
          console.warn(
            `✗ No se encontró equipo para: ${identificadorVisitante} (visitante P${partido.id})`,
          );
        }
      }

      // Actualizar BYEs
      partido.pasaAutomatico =
        partido.local === null || partido.visitante === null;

      // **CORRECIÓN: Solo establecer BYE si realmente falta un equipo**
      if (partido.pasaAutomatico) {
        if (partido.local && !partido.visitante) {
          partido.ganador = partido.local;
          partido.resultado = `BYE (avanza ${partido.local.nombre})`;
          actualizarSiguienteRonda(partido);
        } else if (!partido.local && partido.visitante) {
          partido.ganador = partido.visitante;
          partido.resultado = `BYE (avanza ${partido.visitante.nombre})`;
          actualizarSiguienteRonda(partido);
        }
      } else {
        // Si tiene ambos equipos, asegurarse de limpiar BYE anterior
        partido.ganador = null;
        partido.resultado = "";
      }
    });
  } else {
    console.log("Restaurando usando CRUCES ORIGINALES (sin ediciones)");
    // USAR LOS CRUCES ORIGINALES SIN EDITAR

    // Verificar si los partidos originales tienen equipos reales o predicciones
    const tieneEquiposReales = partidosOriginalesRonda1.value.some(
      (p: any) => p.local && typeof p.local === "object",
    );

    if (tieneEquiposReales) {
      console.log(
        "Los partidos originales ya tienen equipos reales, restaurando estructura...",
      );

      // **CORRECIÓN: No restaurar directamente, sino reasignar equipos actuales**
      ronda1.partidos.forEach((partidoReal: any, index: number) => {
        const partidoOriginal = partidosOriginalesRonda1.value[index];
        if (!partidoOriginal) return;

        // Mantener la estructura pero limpiar resultados
        partidoReal.local = null;
        partidoReal.visitante = null;
        partidoReal.pasaAutomatico = partidoOriginal.pasaAutomatico || false;

        // Solo asignar equipos si existen en los clasificados actuales
        if (
          partidoOriginal.local &&
          typeof partidoOriginal.local === "object"
        ) {
          const equipoEncontrado = clasificados.find(
            (c) => c.id === partidoOriginal.local.id,
          );
          if (equipoEncontrado) {
            partidoReal.local = equipoEncontrado;
          }
        }

        if (
          partidoOriginal.visitante &&
          typeof partidoOriginal.visitante === "object"
        ) {
          const equipoEncontrado = clasificados.find(
            (c) => c.id === partidoOriginal.visitante.id,
          );
          if (equipoEncontrado) {
            partidoReal.visitante = equipoEncontrado;
          }
        }
      });
    } else {
      console.log(
        "Los partidos originales tienen predicciones, reasignando equipos...",
      );

      // **CORRECIÓN: Primero limpiar completamente**
      ronda1.partidos.forEach((partido: any) => {
        partido.local = null;
        partido.visitante = null;
        partido.ganador = null;
        partido.resultado = "";
        partido.pasaAutomatico = false;
        if (!partido.sets || partido.sets.length === 0) {
          // ✅ CREAR SETS DINÁMICAMENTE SEGÚN DEPORTE
          const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
          partido.sets = Array.from({ length: minimosRequeridos }, () => ({
            gamesLocal: null,
            gamesVisitante: null,
          }));
        }
      });

      // Crear predicción original
      const prediccionOriginal = {
        enfrentamientos: partidosOriginalesRonda1.value.map((partido: any) => ({
          local: partido.local,
          visitante: partido.visitante,
          pasaAutomatico: partido.pasaAutomatico,
        })),
      };

      // Función para encontrar equipo
      const encontrarEquipo = (identificador: string) => {
        if (!identificador || typeof identificador !== "string") return null;

        // Patrones comunes
        const matchZona = identificador.match(/(\d+)º de zona (\d+)/);
        if (matchZona) {
          const nivel = parseInt(matchZona[1]);
          const zona = parseInt(matchZona[2]);

          return clasificados.find(
            (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
          );
        }

        const matchMejorDeZona = identificador.match(
          /(\d+)º mejor de zona (\d+)/,
        );
        if (matchMejorDeZona) {
          const nivel = parseInt(matchMejorDeZona[1]);
          const zona = parseInt(matchMejorDeZona[2]);

          return clasificados.find(
            (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
          );
        }

        return buscarEquipoEnClasificados(identificador, clasificados);
      };

      // Reasignar equipos usando la lógica de asignarEquiposOriginal
      prediccionOriginal.enfrentamientos.forEach(
        (partidoPredicho: any, index: number) => {
          const partidoReal = ronda1.partidos[index];
          if (!partidoReal) return;

          const localReal = partidoPredicho.local
            ? encontrarEquipo(partidoPredicho.local as string) || null
            : null;
          const visitanteReal = partidoPredicho.visitante
            ? encontrarEquipo(partidoPredicho.visitante as string) || null
            : null;

          if (localReal && typeof localReal === "object") {
            partidoReal.local = localReal;
          }
          if (visitanteReal && typeof visitanteReal === "object") {
            partidoReal.visitante = visitanteReal;
          }

          partidoReal.pasaAutomatico = partidoPredicho.pasaAutomatico;

          // BYEs automáticos
          if (partidoReal.pasaAutomatico) {
            if (localReal && !visitanteReal) {
              partidoReal.ganador = localReal;
              partidoReal.resultado = `BYE (avanza ${localReal.nombre})`;
              actualizarSiguienteRonda(partidoReal);
            } else if (!localReal && visitanteReal) {
              partidoReal.ganador = visitanteReal;
              partidoReal.resultado = `BYE (avanza ${visitanteReal.nombre})`;
              actualizarSiguienteRonda(partidoReal);
            }
          } else {
            // Limpiar BYE anterior si ahora tiene ambos equipos
            partidoReal.ganador = null;
            partidoReal.resultado = "";
          }
        },
      );
    }
  }

  // **CORRECIÓN ADICIONAL: Limpiar sets de todos los partidos**
  torneo.value.rondas.forEach((ronda: any) => {
    ronda.partidos.forEach((partido: any) => {
      if (!partido.sets || partido.sets.length === 0) {
        // ✅ CREAR SETS DINÁMICAMENTE SEGÚN DEPORTE
        const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
        partido.sets = Array.from({ length: minimosRequeridos }, () => ({
          gamesLocal: null,
          gamesVisitante: null,
        }));
      } else {
        // Limpiar los sets existentes
        partido.sets.forEach((set: any) => {
          set.gamesLocal = null;
          set.gamesVisitante = null;
        });
      }
    });
  });

  // REESTABLECER LAS PREDICCIONES PARA LAS RONDAS 2+
  reestablecerPrediccionesRondasSiguientes();

  // Recalcular conexiones
  nextTick(() => {
    calcularCurvas();
  });

  showAlert({
    icon: "success",
    title: "Cruces restaurados y fase eliminatoria reiniciada.",
    text: "Todos los resultados han sido eliminados de TODAS las rondas.",
    timer: 2500,
    vm: proxy,
  });
}

const todosResultadosZonas = computed(() => {
  if (!torneo.value?.zonas) return false;

  // ⭐ DETECTAR MÍNIMO SEGÚN DEPORTE
  const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;

  return torneo.value.zonas.every((zona: any) =>
    zona.partidos.every(
      (partido: any) =>
        partido.sets &&
        partido.sets.length >= minimosRequeridos && // ✅ DINÁMICO
        partido.sets.every(
          (s: any) =>
            Number.isInteger(s.gamesLocal) &&
            Number.isInteger(s.gamesVisitante),
        ),
    ),
  );
});

const algunResultadoZona = computed(() => {
  if (!torneo.value?.zonas) return false;

  // ⭐ DETECTAR MÍNIMO SEGÚN DEPORTE
  const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;

  return torneo.value.zonas.some((zona: any) =>
    zona.partidos.some(
      (partido: any) =>
        partido.sets &&
        partido.sets.length >= minimosRequeridos && // ✅ DINÁMICO
        partido.sets.every(
          (s: any) =>
            Number.isInteger(s.gamesLocal) &&
            Number.isInteger(s.gamesVisitante),
        ),
    ),
  );
});

const campeon = computed(() => {
  console.log("campeon", torneo.value?.rondas);
  if (!torneo.value?.rondas || torneo.value.rondas.length === 0) return null;
  const finalRonda = torneo.value.rondas[torneo.value.rondas.length - 1];
  if (finalRonda.partidos.length === 1) {
    campeonKey.value++;
    estadoKey.value++;
    return finalRonda.partidos[0].ganador || null;
  }
  return null;
});

function abrirModalResultadoConAdvertencia(partido: any) {
  // Verificar si ya tiene resultado
  const tieneResultado =
    partido.resultado &&
    partido.sets &&
    partido.sets.some(
      (s: any) =>
        Number.isInteger(s.gamesLocal) && Number.isInteger(s.gamesVisitante),
    );

  if (tieneResultado) {
    // Verificar si este partido afecta a rondas posteriores
    const afectaRondasPosteriores = verificarSiAfectaRondasPosteriores(partido);

    if (afectaRondasPosteriores) {
      const confirmacion = confirm(
        `⚠️ ADVERTENCIA\n\nEste partido ya tiene resultados y afecta a partidos posteriores.\n\nSi cambia el resultado, se perderán todos los resultados de la rama afectada (partidos posteriores).\n\n¿Desea continuar?`,
      );

      if (!confirmacion) return;
    }
  }

  // Llamar a la función original
  abrirModalResultado(partido);
}

// Helper para verificar si es un objeto de equipo
function esObjetoEquipo(equipo: any): boolean {
  return (
    equipo && typeof equipo === "object" && "id" in equipo && "nombre" in equipo
  );
}

function obtenerNombreEquipo(equipo: any): string {
  if (!equipo) return "—";
  if (typeof equipo === "string") return equipo;
  if (esObjetoEquipo(equipo)) return equipo.nombre;
  return "—";
}

function abrirModalResultado(partido: any) {
  console.log("Abriendo modal de resultado para:", partido);

  // Validación para partidos de ZONA
  if (!partido.ronda && partido.local && partido.visitante) {
    console.log("Es un partido de zona");
    if (hayResultadosEnFaseEliminacion()) {
      showAlert({
        icon: "warning",
        title:
          "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara modificar resultados de zona, primero debe restaurar los cruces usando el botón '↺ Restaurar Cruces Guardados'.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }
  }

  // Validaciones comunes - verificar que no sean strings (predicciones)
  const localEsPrediccion = typeof partido.local === "string";
  const visitanteEsPrediccion = typeof partido.visitante === "string";

  if (
    !partido.local ||
    !partido.visitante ||
    localEsPrediccion ||
    visitanteEsPrediccion
  ) {
    showAlert({
      icon: "warning",
      title: "Este partido aún no tiene participantes definidos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  partidoActivo.value = partido;

  // Preparar los sets
  sets.value =
    partido.sets && partido.sets.length
      ? partido.sets.map((s: any) => ({
          local: s.gamesLocal,
          visitante: s.gamesVisitante,
        }))
      : [
          { local: null, visitante: null },
          { local: null, visitante: null },
        ];

  modalResultadoVisible.value = true;
  console.log("Modal de resultado abierto");
}

function verificarSiAfectaRondasPosteriores(partido: any) {
  if (!torneo.value?.rondas || !partido.ganador) return false;

  const rondaActualIndex = torneo.value.rondas.findIndex(
    (r: any) => r.numero === partido.ronda,
  );

  if (
    rondaActualIndex === -1 ||
    rondaActualIndex >= torneo.value.rondas.length - 1
  ) {
    return false; // Es la última ronda
  }

  // Verificar si hay resultados en rondas posteriores en esta rama
  const rondaActual = torneo.value.rondas[rondaActualIndex];
  const indicePartido = rondaActual.partidos.findIndex(
    (p: any) => p.id === partido.id,
  );

  if (indicePartido === -1) return false;

  let indiceActual = Math.floor(indicePartido / 2);

  for (let i = rondaActualIndex + 1; i < torneo.value.rondas.length; i++) {
    const rondaSiguiente = torneo.value.rondas[i];
    const partidoSiguiente = rondaSiguiente.partidos[indiceActual];

    if (partidoSiguiente && partidoSiguiente.resultado) {
      return true; // Hay resultados en esta rama
    }

    indiceActual = Math.floor(indiceActual / 2);
  }

  return false;
}

function closeModalResultado() {
  modalResultadoVisible.value = false;
  partidoActivo.value = null;
  sets.value = [];
}

function esEquipoTemporal(equipo: any) {
  return equipo && typeof equipo === "object" && equipo._temporal === true;
}

// Función para resetear la rama del árbol desde un partido específico
function resetearRamaDesdePartido(partidoModificado: any) {
  if (!torneo.value?.rondas || !partidoModificado) return;

  console.log(
    `🔧 Resetando rama desde P${partidoModificado.id} (Ronda ${partidoModificado.ronda})`,
  );

  const rondaActualIndex = partidoModificado.ronda - 1;
  const rondaActual = torneo.value.rondas[rondaActualIndex];

  if (!rondaActual) return;

  const indicePartido = rondaActual.partidos.findIndex(
    (p: any) => p.id === partidoModificado.id,
  );

  if (indicePartido === -1) return;

  // ⭐ CALCULAR MITAD DEL CUADRO
  const totalPartidosRonda = rondaActual.partidos.length;
  const mitadPartidos = totalPartidosRonda / 2;
  const esLadoIzquierdo = indicePartido < mitadPartidos;
  const indiceEnMitad = esLadoIzquierdo
    ? indicePartido
    : indicePartido - mitadPartidos;
  const esLocalEnRondaActual = indiceEnMitad % 2 === 0;

  console.log(
    `📊 Índice: ${indicePartido}, Lado: ${
      esLadoIzquierdo ? "IZQ" : "DER"
    }, Posición: ${esLocalEnRondaActual ? "LOCAL" : "VISITANTE"}`,
  );

  // ⭐ PASO 1: ENCONTRAR EL PARTIDO SIGUIENTE (ronda N+1)
  const rondaSiguienteIndex = rondaActualIndex + 1;
  const rondaSiguiente = torneo.value.rondas[rondaSiguienteIndex];

  if (!rondaSiguiente) {
    console.log(`⚠️ No hay ronda siguiente`);
    return;
  }

  // Calcular índice en la ronda siguiente
  const indiceEnRondaSiguiente = Math.floor(indiceEnMitad / 2);
  const indicePartidoSiguiente = esLadoIzquierdo
    ? indiceEnRondaSiguiente
    : rondaSiguiente.partidos.length / 2 + indiceEnRondaSiguiente;

  const partidoSiguiente = rondaSiguiente.partidos[indicePartidoSiguiente];

  if (!partidoSiguiente) {
    console.log(
      `⚠️ No hay partido en ronda ${
        rondaSiguienteIndex + 1
      }, índice ${indicePartidoSiguiente}`,
    );
    return;
  }

  console.log(
    `🎯 Partido siguiente: P${partidoSiguiente.id} en ronda ${rondaSiguiente.numero}`,
  );

  // ⭐ PASO 2: ACTUALIZAR SOLO EL LADO AFECTADO EN RONDA N+1
  const vieneComoLocal = esLocalEnRondaActual;

  if (vieneComoLocal) {
    // Actualizar solo el LOCAL (lado afectado)
    partidoSiguiente.local = partidoModificado.ganador || {
      nombre: `Ganador P${partidoModificado.id}`,
    };
    console.log(`✓ Actualizado LOCAL: ${partidoSiguiente.local.nombre}`);

    // Mantener el VISITANTE (rival)
    if (!partidoSiguiente.visitante) {
      const indiceOponente = esLocalEnRondaActual
        ? indicePartido + 1
        : indicePartido - 1;
      const partidoOponente = rondaActual.partidos[indiceOponente];

      if (partidoOponente) {
        partidoSiguiente.visitante = {
          nombre: `Ganador P${partidoOponente.id}`,
        };
        console.log(
          `✓ Establecido VISITANTE (predicción): Ganador P${partidoOponente.id}`,
        );
      }
    }
  } else {
    // Actualizar solo el VISITANTE (lado afectado)
    partidoSiguiente.visitante = partidoModificado.ganador || {
      nombre: `Ganador P${partidoModificado.id}`,
    };
    console.log(
      `✓ Actualizado VISITANTE: ${partidoSiguiente.visitante.nombre}`,
    );

    // Mantener el LOCAL (rival)
    if (!partidoSiguiente.local) {
      const indiceOponente = esLocalEnRondaActual
        ? indicePartido + 1
        : indicePartido - 1;
      const partidoOponente = rondaActual.partidos[indiceOponente];

      if (partidoOponente) {
        partidoSiguiente.local = { nombre: `Ganador P${partidoOponente.id}` };
        console.log(
          `✓ Establecido LOCAL (predicción): Ganador P${partidoOponente.id}`,
        );
      }
    }
  }

  // ⭐ PASO 3: RESETEAR RESULTADO DEL PARTIDO SIGUIENTE
  partidoSiguiente.ganador = null;
  partidoSiguiente.resultado = "";
  const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
  partidoSiguiente.sets = Array.from({ length: minimosRequeridos }, () => ({
    gamesLocal: null,
    gamesVisitante: null,
  }));

  console.log(`✓ Resultado de P${partidoSiguiente.id} reseteado`);

  // ⭐ PASO 4: PROPAGAR EL CAMBIO HACIA LAS RONDAS POSTERIORES
  // Esto es lo que estaba faltando - convertir a predicción en rondas N+2+
  propagarCambioHaciaRondasPosteriores(
    partidoSiguiente,
    esLadoIzquierdo,
    vieneComoLocal,
  );

  // Forzar actualización visual
  campeonKey.value++;
  console.log(`✅ Cambio aplicado correctamente`);
}

function guardarResultado(modalSets: any) {
  if (!partidoActivo.value) return;

  // IMPORTANTE: Obtener el deporte actual
  const deporteActual = deporte.value || "tenis"; // Variable reactiva que debe existir en el componente

  // ============================================
  // VALIDACIONES SEGÚN DEPORTE
  // ============================================
  if (deporteActual === "Futbol") {
    // FÚTBOL: Solo necesita 1 "set" (que contiene los goles)
    if (modalSets.length < 1) {
      showAlert({
        icon: "warning",
        title: "Debe ingresar el resultado del partido.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    const goles = modalSets[0];
    if (
      !Number.isInteger(goles.gamesLocal) ||
      !Number.isInteger(goles.gamesVisitante) ||
      goles.gamesLocal < 0 ||
      goles.gamesVisitante < 0
    ) {
      showAlert({
        icon: "warning",
        title: "Debe ingresar la cantidad de goles de ambos equipos.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    // VALIDACIÓN ESPECIAL: En eliminación NO puede haber empates
    const esEliminacion = partidoActivo.value.ronda !== undefined;
    if (esEliminacion && goles.gamesLocal === goles.gamesVisitante) {
      showAlert({
        icon: "warning",
        title:
          "En fase de eliminación no puede haber empates. Debe definirse un ganador.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }
  } else {
    // TENIS/PADEL: Necesita mínimo 2 sets
    if (modalSets.length < 2) {
      showAlert({
        icon: "warning",
        title: "Se necesitan mínimo 2 sets.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    for (let i = 0; i < modalSets.length; i++) {
      const s = modalSets[i];
      if (
        !Number.isInteger(s.gamesLocal) ||
        !Number.isInteger(s.gamesVisitante)
      ) {
        showAlert({
          icon: "warning",
          title: "Completar todos los games de cada set con números enteros.",
          timer: 4000,
          vm: proxy,
        });
        return;
      }

      if (s.gamesLocal < 0 || s.gamesVisitante < 0) {
        showAlert({
          icon: "warning",
          title: "Los games no pueden ser números negativos.",
          timer: 4000,
          vm: proxy,
        });
        return;
      }
    }
  }

  // ============================================
  // GUARDAR GANADOR ANTERIOR
  // ============================================
  const ganadorAnterior = partidoActivo.value.ganador;

  // ============================================
  // CALCULAR GANADOR Y RESULTADO USANDO UTILIDAD
  // ============================================

  const { ganador, resultado } = calcularGanador(
    modalSets,
    partidoActivo.value.local,
    partidoActivo.value.visitante,
    deporteActual,
  );

  // Guardar sets (normalizados)
  partidoActivo.value.sets = modalSets.map((s: any) => ({
    gamesLocal: Number(s.gamesLocal),
    gamesVisitante: Number(s.gamesVisitante),
  }));

  // Asignar ganador y resultado
  partidoActivo.value.ganador = ganador;
  partidoActivo.value.resultado = resultado;

  // ============================================
  // LIMPIAR FLAGS TEMPORALES (solo para torneos)
  // ============================================
  if (typeof limpiarFlagsTemporales === "function") {
    limpiarFlagsTemporales();
  }

  // ============================================
  // DETECTAR SI ES MODIFICACIÓN
  // ============================================
  const esModificacion =
    ganadorAnterior !== null && ganadorAnterior !== undefined;

  // ============================================
  // ACTUALIZAR SIGUIENTES RONDAS (solo torneos)
  // ============================================
  if (partidoActivo.value.ronda) {
    // Es un partido de eliminación
    if (esModificacion && ganadorAnterior?.id !== ganador?.id) {
      // El ganador cambió: resetear rama completa
      console.log(
        `¡Ganador cambiado! Resetando rama desde P${partidoActivo.value.id}`,
      );

      if (typeof resetearRamaDesdePartido === "function") {
        resetearRamaDesdePartido(partidoActivo.value);
      }
    } else {
      // Ganador igual o es nuevo: actualizar normalmente
      if (typeof actualizarSiguienteRonda === "function") {
        actualizarSiguienteRonda({ ...partidoActivo.value });
      }

      if (typeof forzarRecalculoCurvas === "function") {
        forzarRecalculoCurvas();
      }
    }
  }

  // ============================================
  // CERRAR MODAL Y LIMPIAR
  // ============================================
  modalResultadoVisible.value = false;

  // Forzar reactividad (si es necesario)
  if (torneo.value) {
    torneo.value = { ...torneo.value };
  }

  partidoActivo.value = null;

  // ============================================
  // MOSTRAR CONFIRMACIÓN
  // ============================================
  showAlert({
    icon: "success",
    title: "Resultado guardado correctamente.",
    timer: 2500,
    vm: proxy,
  });
}

function editarNombreEquipoEliminacion(
  partido: any,
  ronda: any,
  condicion: string,
) {
  // Guardar referencia al partido y equipo a editar
  console.log("partido", partido);
  const equipoAEditar =
    condicion === "local" ? partido.local : partido.visitante;

  if (!equipoAEditar) {
    showAlert({
      icon: "warning",
      title: "No hay equipo para editar en este partido.",
      timer: 3000,
      vm: proxy,
    });
    return;
  }

  // Determinar cuál equipo estamos editando
  const esLocal = partido.local === equipoAEditar;

  // Obtener IDs de jugadores ya usados (excluyendo el equipo actual)
  const idsUsados = obtenerIdsJugadoresUsados(equipoAEditar);

  equipoActivo.value = equipoAEditar;

  // Guardar los IDs usados en el equipo activo
  equipoActivo.value._idsUsados = idsUsados;

  zonaActiva.value = {
    partido,
    esLocal,
    ronda,
  };

  if (!usaJugadores.value) {
    // ⭐ FÚTBOL: Editar nombre directamente
    editarNombreEquipoFutbol(equipoActivo.value, zonaActiva.value);
    return;
  }

  modalAsignarJugadoresVisible.value = true;
}

function editarNombreEquipo(zona: any, equipo: any) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está publicado. Vuelva a ponerlo en estado Draft.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  if (!usaJugadores.value) {
    // ⭐ FÚTBOL: Editar nombre directamente
    editarNombreEquipoFutbol(equipo, zona);
    return;
  }

  // TENIS/PADEL: Asignar jugadores
  equipoActivo.value = equipo;
  zonaActiva.value = zona;
  equipoActivo.value._idsUsados = obtenerIdsJugadoresUsados(equipo);
  modalAsignarJugadoresVisible.value = true;
}

function editarNombreEquipoFutbol(equipo: any, zona?: any) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está publicado.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  equipoActivo.value = equipo;
  zonaActiva.value = zona || null;
  modalAsignarNombreVisible.value = true;
}

function asignarNombreEquipoFutbol(nombre: string) {
  if (!equipoActivo.value) return;

  const equipoId = equipoActivo.value.id;
  equipoActivo.value.nombre = nombre;

  // ⭐ VARIABLE PARA GUARDAR PARTIDOS CON BYE
  const partidosConBye: any[] = [];

  // Propagar cambio a todos los partidos
  if (torneo.value && equipoId) {
    // En zonas
    if (torneo.value.zonas) {
      torneo.value.zonas.forEach((zona: any) => {
        zona.partidos.forEach((partido: any) => {
          if (partido.local?.id === equipoId) partido.local.nombre = nombre;
          if (partido.visitante?.id === equipoId)
            partido.visitante.nombre = nombre;
          if (partido.ganador?.id === equipoId) partido.ganador.nombre = nombre;
        });
      });
    }

    // En eliminación
    if (torneo.value.rondas) {
      torneo.value.rondas.forEach((ronda: any) => {
        ronda.partidos.forEach((partido: any) => {
          // ⭐ DETECTAR BYE ANTES DE ACTUALIZAR NOMBRES - CONDICIÓN CORREGIDA
          if (partido.pasaAutomatico) {
            console.log("here");
            // Verificar si es un BYE donde este equipo es el único presente
            const esLocalConBye =
              partido.local?.id === equipoId && !partido.visitante;
            const esVisitanteConBye =
              partido.visitante?.id === equipoId && !partido.local;

            if (esLocalConBye || esVisitanteConBye) {
              partidosConBye.push(partido);
            }
          }

          // Actualizar nombres
          if (partido.local?.id === equipoId) partido.local.nombre = nombre;
          if (partido.visitante?.id === equipoId)
            partido.visitante.nombre = nombre;
          if (partido.ganador?.id === equipoId) partido.ganador.nombre = nombre;
        });
      });
    }
  }

  // ⭐ PROCESAR BYEs DESPUÉS DE ACTUALIZAR TODOS LOS NOMBRES
  if (partidosConBye.length > 0) {
    console.log(
      `🔍 Encontré ${partidosConBye.length} partidos con BYE para actualizar`,
    );

    partidosConBye.forEach((partido: any) => {
      const ganador = partido.local || partido.visitante;

      if (ganador) {
        console.log(
          `🎯 Procesando BYE para ${ganador.nombre} en P${partido.id}`,
        );

        partido.ganador = ganador;
        partido.resultado = `BYE (avanza ${ganador.nombre})`;

        // ⭐ AVANZAR A LA SIGUIENTE RONDA
        actualizarSiguienteRonda(partido);

        console.log(`✅ ${ganador.nombre} avanzó automáticamente por BYE`);
      }
    });
  }

  hayCambiosSinGuardar.value = true;
  modalAsignarNombreVisible.value = false;
  equipoActivo.value = null;
  zonaActiva.value = null;

  showAlert({
    icon: "success",
    title: `Nombre del equipo actualizado: ${nombre}`,
    timer: 2500,
    vm: proxy,
  });
}

function asignarJugadoresAEquipoActivo(jugadores: any) {
  console.log("jugadores", jugadores);
  const splitJugador1 = jugadores.jugador1.value.nombreJugador.split(",");
  const nombreJugador1 =
    splitJugador1[0] + " " + splitJugador1[1].trim().substr(0, 1) + ".";
  const idJugador1 = jugadores.jugador1.value.idJugador;

  let nombreJugador2 = "";
  let idJugador2 = null;

  if (tipoCompetenciaTorneo.value === "Dobles") {
    const splitJugador2 = jugadores.jugador2.value.nombreJugador.split(",");
    nombreJugador2 =
      splitJugador2[0] + " " + splitJugador2[1].trim().substr(0, 1) + ".";
    idJugador2 = jugadores.jugador2.value.idJugador;
  }

  let nombreEquipo = nombreJugador1;

  if (tipoCompetenciaTorneo.value === "Dobles") {
    nombreEquipo += ` - ${nombreJugador2}`;
  }

  const ids = { idJugador1, idJugador2 };

  if (ids.idJugador2 == null) {
    delete ids.idJugador2;
  }

  // CASO ESPECIAL: Eliminación directa
  if (modalidad.value === "eliminacion_directa" && zonaActiva.value?.partido) {
    const partido = zonaActiva.value.partido;
    const esLocal = zonaActiva.value.esLocal;

    // Actualizar el equipo directamente en el partido
    const equipoActualizado = {
      ...equipoActivo.value,
      nombre: nombreEquipo,
      ids,
    };

    if (esLocal) {
      partido.local = equipoActualizado;
    } else {
      partido.visitante = equipoActualizado;
    }

    // Propagar cambios a rondas siguientes si ya tiene ganador
    if (partido.ganador && partido.ganador.id === equipoActivo.value.id) {
      partido.ganador = equipoActualizado;
      actualizarSiguienteRonda(partido);
    }
  } else {
    // CASO NORMAL: Zonas (código existente)
    actualizarNombreEquipoEnObjeto(
      torneo.value,
      equipoActivo.value?.id,
      nombreEquipo,
      ids,
    );
  }

  modalAsignarJugadoresVisible.value = false;
  equipoActivo.value = null;
  zonaActiva.value = null;
}

// Función para resetear jugadores de un equipo en ZONAS
async function resetearJugadoresEquipo(equipo: any, zona: any) {
  if (!usaJugadores.value) {
    // Fútbol no tiene esta opción
    return;
  }
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para resetear jugadores.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  if (hayResultadosEnFaseEliminacion()) {
    showAlert({
      icon: "warning",
      title:
        "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara resetear jugadores, primero debe restaurar los cruces.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Resetear jugadores",
    text: `¿Está seguro que desea resetear los jugadores del equipo "${equipo.nombre}"? El nombre volverá a su valor por defecto.`,
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonText: "Sí, resetear",
    cancelButtonText: "Cancelar",
  });

  if (!result.isConfirmed) return;

  // Resetear el nombre al valor por defecto basado en el ID
  const nombrePorDefecto = `Equipo ${zona.id}-${
    zona.equipos.indexOf(equipo) + 1
  }`;

  // Eliminar los ids de jugadores
  delete equipo.ids;

  // Restaurar nombre por defecto
  equipo.nombre = nombrePorDefecto;

  showAlert({
    icon: "success",
    title: `Jugadores del equipo reseteados correctamente.`,
    timer: 2500,
    vm: proxy,
  });

  console.log(`🔄 Equipo reseteado: ${equipo.nombre}`);
}

async function confirmaFinalizacionTorneo() {
  const result = await confirmModal({
    vm: proxy,
    title: "Finalizar torneo.",
    text: "¿Está seguro que desea finalizar el torneo? Esta acción no se puede deshacer.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  abrirModalFinalizar();
}

// Función para resetear jugadores de un equipo en ELIMINACIÓN DIRECTA
async function resetearJugadoresEquipoEliminacion(
  partido: any,
  posicion: "local" | "visitante",
) {
  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden resetear jugadores.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const equipo = posicion === "local" ? partido.local : partido.visitante;

  if (!equipo || !esObjetoEquipo(equipo)) {
    showAlert({
      icon: "warning",
      title: "No hay equipo para resetear.",
      timer: 3000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Resetear jugadores",
    text: `¿Está seguro que desea resetear los jugadores del equipo "${equipo.nombre}"? El nombre volverá a su valor por defecto.`,
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonText: "Sí, resetear",
    cancelButtonText: "Cancelar",
  });

  if (!result.isConfirmed) return;

  // Resetear el nombre al valor por defecto basado en el ID
  const nombrePorDefecto = `Equipo ${equipo.id}`;

  // Crear equipo reseteado
  const equipoReseteado = {
    id: equipo.id,
    nombre: nombrePorDefecto,
  };

  // Actualizar el partido
  if (posicion === "local") {
    partido.local = equipoReseteado;
  } else {
    partido.visitante = equipoReseteado;
  }

  // Si este equipo era el ganador, resetear el ganador también
  if (partido.ganador && partido.ganador.id === equipo.id) {
    partido.ganador = null;
    partido.resultado = "";
    const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
    partido.sets = Array.from({ length: minimosRequeridos }, () => ({
      gamesLocal: null,
      gamesVisitante: null,
    }));

    // Resetear rondas posteriores
    resetearRamaDesdePartido(partido);
  }

  // Propagar cambios a través de las rondas si el equipo ya avanzó
  if (partido.ganador && partido.ganador.id === equipo.id) {
    actualizarSiguienteRonda(partido);
  }

  showAlert({
    icon: "success",
    title: `Jugadores del equipo reseteados correctamente.`,
    timer: 2500,
    vm: proxy,
  });

  console.log(`🔄 Equipo reseteado en eliminación: ${equipoReseteado.nombre}`);

  // Forzar actualización visual
  nextTick(() => {
    calcularCurvas();
  });
}

function obtenerIdsJugadoresUsados(equipoExcluido?: any): number[] {
  const idsUsados: number[] = [];

  if (!torneo.value) return idsUsados;

  // Función helper para extraer IDs de un equipo
  const extraerIdsDeEquipo = (equipo: any) => {
    if (!equipo || !esObjetoEquipo(equipo)) return;

    // Si es el equipo que estamos editando, no incluir sus IDs
    if (equipoExcluido && equipo.id === equipoExcluido.id) return;

    if (equipo.ids) {
      if (equipo.ids.idJugador1) {
        idsUsados.push(equipo.ids.idJugador1);
      }
      if (equipo.ids.idJugador2) {
        idsUsados.push(equipo.ids.idJugador2);
      }
    }
  };

  // CASO 1: Torneo con ZONAS
  if (torneo.value.zonas && Array.isArray(torneo.value.zonas)) {
    torneo.value.zonas.forEach((zona: any) => {
      if (zona.equipos && Array.isArray(zona.equipos)) {
        zona.equipos.forEach((equipo: any) => {
          extraerIdsDeEquipo(equipo);
        });
      }
    });
  }

  // CASO 2: Torneo de ELIMINACIÓN DIRECTA
  // Recorrer todas las rondas y extraer equipos
  if (torneo.value.rondas && Array.isArray(torneo.value.rondas)) {
    // Solo necesitamos revisar la primera ronda, ya que los equipos se repiten
    const primeraRonda = torneo.value.rondas[0];

    if (primeraRonda && primeraRonda.partidos) {
      primeraRonda.partidos.forEach((partido: any) => {
        extraerIdsDeEquipo(partido.local);
        extraerIdsDeEquipo(partido.visitante);
      });
    }
  }

  // Eliminar duplicados
  const idsUnicos = [...new Set(idsUsados)];

  console.log(`📋 IDs de jugadores ya usados en el torneo:`, idsUnicos);
  console.log(`🚫 Equipo excluido:`, equipoExcluido?.nombre || "Ninguno");

  return idsUnicos;
}

function actualizarNombreEquipoEnObjeto(
  obj: any,
  equipoId: any,
  nuevoNombre: any,
  ids: any,
) {
  if (Array.isArray(obj)) {
    obj.forEach((item) =>
      actualizarNombreEquipoEnObjeto(item, equipoId, nuevoNombre, ids),
    );
    return;
  }

  if (obj && typeof obj === "object") {
    if (
      obj.id === equipoId &&
      typeof obj.nombre === "string" &&
      !obj.equipos?.length
    ) {
      obj.nombre = nuevoNombre;

      // Si ids es null o undefined, eliminar la propiedad
      if (ids === null || ids === undefined) {
        delete obj.ids;
      } else {
        obj.ids = ids;
      }
    }

    Object.values(obj).forEach((value) =>
      actualizarNombreEquipoEnObjeto(value, equipoId, nuevoNombre, ids),
    );
  }
}

async function eliminarEquipo(zona: any, equipo: any) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para eliminar el equipo.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }
  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden mover los equipos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }
  // Verificar si ya hay resultados en fase eliminatoria
  if (hayResultadosEnFaseEliminacion()) {
    showAlert({
      icon: "warning",
      title:
        "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara eliminar equipos, primero debe restaurar los cruces usando el botón '↺ Restaurar Cruces Guardados'.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  const equipoIndex = zona.equipos.findIndex((e: any) => e.id === equipo.id);

  if (equipoIndex === -1) {
    showAlert({
      icon: "warning",
      title: `No se encotró el equipo.`,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  // Verificar cantidad mínima de equipos
  if (zona.equipos.length <= 2) {
    showAlert({
      icon: "warning",
      title: `No se puede eliminar. La ${zona.nombre} necesita al menos 2 equipos.`,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Eliminar equipo.",
    text: "¿Está seguro que desea eliminar el equipo? Se regenerarán los partidos.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  // Eliminar equipo
  zona.equipos.splice(equipoIndex, 1);
  total.value -= 1;
  torneo.value.total -= 1;

  // Eliminar partidos relacionados con este equipo
  if (zona.partidos) {
    // Filtrar partidos donde participa el equipo eliminado
    const partidosAEliminar = zona.partidos.filter(
      (partido: any) =>
        partido.local?.id === equipo.id || partido.visitante?.id === equipo.id,
    );

    // Eliminar esos partidos
    partidosAEliminar.forEach((partido: any) => {
      const partidoIndex = zona.partidos.findIndex(
        (p: any) => p.id === partido.id,
      );
      if (partidoIndex !== -1) {
        zona.partidos.splice(partidoIndex, 1);
      }
    });

    // Regenerar todos los partidos de la zona
    zona.partidos = generarPartidosDeZona(zona.equipos, deporte.value);

    // Reasignar IDs a los partidos restantes
    zona.partidos.forEach((partido: any, index: number) => {
      partido.id = index + 1;
    });
  }

  // Actualizar fase de eliminación si ya hay resultados
  if (todosResultadosZonas.value) {
    actualizarFaseEliminacion();
  }

  showAlert({
    icon: "success",
    title: `Equipo "${equipo.nombre}" eliminado de la ${zona.nombre}`,
    timer: 2500,
    vm: proxy,
  });
}

// Y esta función para limpiar refs viejos
function limpiarRefsPartidos() {
  Object.keys(partidoRefs).forEach((key) => {
    delete partidoRefs[key];
    console.log("🧹 Refres de partidos limpiados");
  });
}

async function generarTorneoClick() {
  try {
    console.log("🚀 Generando torneo...");

    if (estadoTorneo.value === "Publicado") {
      showAlert({
        icon: "warning",
        title:
          "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para generar o regenerar los partidos.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    if (+total.value > 256) {
      showAlert({
        icon: "warning",
        title: "La cantidad total de equipos no puede ser mayor a 256.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    if (modalidad.value === "zonas_y_eliminacion" && !clasificados.value) {
      showAlert({
        icon: "warning",
        title: "Debe definir la cantidad total de clasificados.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    if (algunResultadoZona.value || hayResultadosEnFaseEliminacion()) {
      const result = await confirmModal({
        vm: proxy,
        title: "Torneo empezado.",
        text: "Hay resultados cargados, si regenera los partidos se perderán los mismos. ¿Desea regenerar los partidos de todas maneras?",
        icon: "warning",
        showCancelButton: true,
        showCloseButton: true,
      });

      if (!result.isConfirmed) {
        return;
      }
    }

    // Limpiar refs anteriores
    limpiarRefsPartidos();
    curves.value = [];
    partidoRefsReady.value = false;

    // Generar torneo
    torneo.value = generarTorneo(
      total.value,
      modalidad.value,
      clasificados.value,
      zonasDeseadas.value,
      estrategiaByes.value,
      deporte.value,
    );

    if (!torneo.value) {
      console.warn("❌ generarTorneo devolvió null");
      showAlert({
        icon: "warning",
        title:
          "Los partidos no pudieros ser generados con los parámetros ingresados.",
        timer: 4000,
        vm: proxy,
      });
      return;
    }

    console.log(
      `✅ Torneo generado con ${torneo.value.rondas?.length || 0} rondas`,
    );

    // Guardar partidos originales
    if (torneo.value.rondas?.[0]?.partidos) {
      partidosOriginalesRonda1.value = JSON.parse(
        JSON.stringify(torneo.value.rondas[0].partidos),
      );
      console.log(
        `💾 Partidos originales guardados: ${partidosOriginalesRonda1.value.length}`,
      );
    }

    // Crear zonas si es necesario
    if (
      torneo.value.participantesPorZona &&
      modalidad.value === "zonas_y_eliminacion"
    ) {
      ignoreNextZonaChange.value = true;

      torneo.value.zonas = torneo.value.participantesPorZona.map(
        (cant: number, index: number) => {
          const equipos = Array.from({ length: cant }, (_, i) => ({
            id: index * 1000 + i + 1,
            nombre: `Equipo ${index + 1}-${i + 1}`,
          }));

          const zona = {
            id: index + 1,
            nombre: `Zona ${index + 1}`,
            equipos,
            partidos: [],
            cantClasificados: torneo.value.clasificadosPorZona[index],
          };

          zona.partidos = generarPartidosDeZona(zona.equipos, deporte.value);
          console.log(
            `🏟️ Zona ${zona.id} creada con ${zona.equipos.length} equipos`,
          );
          return zona;
        },
      );
    }

    // Esperar múltiples ciclos de renderizado
    await nextTick();
    await nextTick();
    await nextTick(); // Un ciclo adicional

    // Marcar que los refs están listos
    partidoRefsReady.value = true;
    console.log("✅ Refs marcados como listos");

    await guardarCambios();

    showAlert({
      icon: "success",
      title: "Partidos generados exitosamente!",
      timer: 2500,
      vm: proxy,
    });

    // Cambiar a la pestaña apropiada
    if (modalidad.value === "eliminacion_directa") {
      tab.value = 2; // Ir directamente a fase eliminación
      console.log("➡️ Cambiando a pestaña Eliminación Directa");
    } else {
      tab.value = 1; // Ir a zonas
      console.log("➡️ Cambiando a pestaña Zonas");
    }

    ignoreNextZonaChange.value = false;
  } catch (error) {
    showAlert({
      icon: "warning",
      title: error || error.message,
      timer: 4000,
      vm: proxy,
    });
  }
}

function agregarEquipo(zona: any) {
  if (estadoTorneo.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "El torneo ya está publicado. Vuelva a ponerlo en estado Draft para agregar equipo.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  if (estadoTorneo.value === "Finalizado") {
    showAlert({
      icon: "warning",
      title: "El torneo ya está finalizado. No se pueden mover los equipos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  // Verificar si ya hay resultados en fase eliminatoria
  if (hayResultadosEnFaseEliminacion()) {
    showAlert({
      icon: "warning",
      title:
        "❌ Ya hay partidos jugados en la fase de eliminación.\n\nPara agregar equipos, primero debe restaurar los cruces usando el botón '↺ Restaurar Cruces Guardados'.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (todosResultadosZonas.value) {
    showAlert({
      icon: "warning",
      title: "Ya se jugaron todos los partidos de zona.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  zona.equipos.push({
    id: Date.now(),
    nombre: `Equipo ${zona.id}-${zona.equipos.length + 1}`,
  });
  total.value += 1;
  torneo.value.total += 1;

  regenerarPartidosDeZona(zona);

  showAlert({
    icon: "success",
    title: `Equipo agregado exitosamente a la zona ${zona.nombre}.`,
    timer: 2500,
    vm: proxy,
  });
}

function calcularCurvas() {
  // Evitar loops - no calcular si ya estamos calculando
  if (calculandoCurvas.value) {
    console.log("⏸️ Ya se están calculando curvas, omitiendo...");
    return;
  }

  // Debounce: no calcular más de una vez cada 500ms
  const ahora = Date.now();
  if (ahora - ultimoCalculo.value < 500) {
    console.log("⏸️ Debounce: esperando...");
    return;
  }

  calculandoCurvas.value = true;
  ultimoCalculo.value = ahora;

  console.log("🔧 Calculando curvas...");

  try {
    curves.value = [];

    if (
      !torneo.value ||
      !torneo.value.rondas ||
      torneo.value.rondas.length < 2
    ) {
      console.log("⚠️ No hay suficientes rondas para calcular curvas");
      return;
    }

    if (!rondasContainer.value) {
      console.warn("❌ No se encontró el contenedor de rondas");
      return;
    }

    // Actualizar dimensiones una sola vez
    svgWidth.value = rondasContainer.value.offsetWidth;
    svgHeight.value = rondasContainer.value.offsetHeight;

    console.log(`📐 Dimensiones SVG: ${svgWidth.value}x${svgHeight.value}`);
    console.log(`📊 Refs disponibles: ${Object.keys(partidoRefs).length}`);

    // Calcular de inmediato (sin setTimeout interno)
    const nuevasCurves: Array<{ id: string; d: string }> = [];
    const rectContainer = rondasContainer.value!.getBoundingClientRect();

    torneo.value.rondas.forEach((ronda: any, rondaIndex: number) => {
      if (rondaIndex >= torneo.value.rondas.length - 1) return;

      const siguienteRonda = torneo.value.rondas[rondaIndex + 1];

      ronda.partidos.forEach((partido: any, partidoIndex: number) => {
        const siguientePartidoIndex = Math.floor(partidoIndex / 2);
        const siguientePartido = siguienteRonda.partidos[siguientePartidoIndex];

        if (!siguientePartido) return;

        const elementoPartido = partidoRefs[partido.id];
        const elementoSiguiente = partidoRefs[siguientePartido.id];

        if (!elementoPartido || !elementoSiguiente) {
          console.log(
            `⚠️ Falta ref para P${partido.id} o P${siguientePartido.id}`,
          );
          return;
        }

        try {
          const elPartido = elementoPartido.$el || elementoPartido;
          const elSiguiente = elementoSiguiente.$el || elementoSiguiente;

          const rectPartido = elPartido.getBoundingClientRect();
          const rectSiguiente = elSiguiente.getBoundingClientRect();

          // Convertir a coordenadas relativas al contenedor
          const x1 = rectPartido.right - rectContainer.left;
          const y1 =
            rectPartido.top + rectPartido.height / 2 - rectContainer.top;
          const x2 = rectSiguiente.left - rectContainer.left;
          const y2 =
            rectSiguiente.top + rectSiguiente.height / 2 - rectContainer.top;

          // Línea en "L"
          const puntoMedioX = (x1 + x2) / 2;
          const d = `M ${x1},${y1}
                    L ${puntoMedioX},${y1}
                    L ${puntoMedioX},${y2}
                    L ${x2},${y2}`;

          nuevasCurves.push({
            id: `${partido.id}-${siguientePartido.id}`,
            d,
          });
        } catch (error) {
          console.error(
            `Error en línea ${partido.id}->${siguientePartido.id}:`,
            error,
          );
        }
      });
    });

    // Asignar una sola vez
    curves.value = nuevasCurves;
    console.log(`✅ ${curves.value.length} líneas calculadas`);
  } catch (error) {
    console.error("❌ Error calculando curvas:", error);
  } finally {
    // Liberar el flag después de un breve delay
    setTimeout(() => {
      calculandoCurvas.value = false;
    }, 100);
  }
}

async function volver() {
  if (hayCambiosSinGuardar.value) {
    const result = await confirmModal({
      vm: proxy,
      title: "Cambios sin guardar.",
      text: "Posee cambios sin guardar.",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: "Volver",
      confirmButtonText: "Guardar y volver",
    });

    if (result.isConfirmed) {
      guardarCambios();
    }
  }
  proxy.$router.push("/lista-competiciones");
}

// Modificar forzarRecalculoCurvas
async function forzarRecalculoCurvas() {
  if (calculandoCurvas.value) {
    console.log("⏸️ Ya se está forzando recálculo, omitiendo...");
    return;
  }

  console.log("🔄 Forzando recálculo de curvas...");

  // Limpiar primero
  curves.value = [];

  // Esperar a que Vue actualice
  await nextTick();
  await nextTick();

  // Pequeño delay para asegurar renderizado
  await new Promise((resolve) => setTimeout(resolve, 50));

  // Calcular
  calcularCurvas();
}

function cambiarEstado(estado: string) {
  estadoTorneo.value = estado;
}

onMounted(async () => {
  window.addEventListener("resize", forzarRecalculoCurvas);
  // Recalcular después de que todo esté montado
  setTimeout(forzarRecalculoCurvas, 100);

  const params = {
    idTorneo: proxy.$route.params.id,
  };

  const { data } = await axios.get("/Torneos/GetTorneoById", {
    params,
  });

  nombreTorneo.value = data.nombre;
  categoriaTorneo.value = data.categoria;
  generoTorneo.value = data.genero;
  tipoCompetenciaTorneo.value = data.tipoCompetencia;
  estadoTorneo.value = data.estado;
  idTorneo.value = data.idTorneo;
  idInstitucion.value = data.idInstitucion;
  deporte.value = data.deporte;

  infoTorneo.value = `${nombreTorneo.value} - Categoría: ${categoriaTorneo.value} - Género: ${generoTorneo.value}`;

  if (data.configuraciones) {
    const configuraciones = JSON.parse(data.configuraciones);

    console.log("configuraciones", configuraciones);
    torneo.value = { ...configuraciones };
    total.value = configuraciones.total;
    modalidad.value = configuraciones.formato;
    clasificados.value = configuraciones.totalClasificados;
    estrategiaByes.value = configuraciones.estrategiaByes;
    zonasDeseadas.value = configuraciones.zonasDeseadas;
    await nextTick();
  }

  guardarInterval.value = setInterval(() => {
    if (hayCambiosSinGuardar.value && estadoTorneo.value !== "Finalizado") {
      guardarCambios();
    }
  }, 30000);
});

onUnmounted(() => {
  clearInterval(guardarInterval.value);
  window.removeEventListener("resize", forzarRecalculoCurvas);
});

// function calcularTablaZona(zona: any) {
//   // returns array sorted by points, then set diff, then game diff
//   const mapa = new Map();
//   zona.equipos.forEach((eq: any) =>
//     mapa.set(eq.id, {
//       equipo: eq,
//       puntos: 0,
//       setsGanados: 0,
//       setsPerdidos: 0,
//       gamesGanados: 0,
//       gamesPerdidos: 0,
//       pj: 0,
//     }),
//   );

//   zona.partidos.forEach((p: any) => {
//     if (!p.sets || p.sets.length < 2) return;
//     const local = mapa.get(p.local.id);
//     const visitante = mapa.get(p.visitante.id);
//     local.pj++;
//     visitante.pj++;
//     let setsLocal = 0,
//       setsVisitante = 0;
//     p.sets.forEach((s: any) => {
//       if (
//         !Number.isInteger(s.gamesLocal) ||
//         !Number.isInteger(s.gamesVisitante)
//       )
//         return;
//       local.gamesGanados += s.gamesLocal;
//       local.gamesPerdidos += s.gamesVisitante;
//       visitante.gamesGanados += s.gamesVisitante;
//       visitante.gamesPerdidos += s.gamesLocal;
//       if (s.gamesLocal > s.gamesVisitante) {
//         setsLocal++;
//       } else if (s.gamesVisitante > s.gamesLocal) {
//         setsVisitante++;
//       }
//     });
//     local.setsGanados += setsLocal;
//     local.setsPerdidos += setsVisitante;
//     visitante.setsGanados += setsVisitante;
//     visitante.setsPerdidos += setsLocal;
//     if (setsLocal > setsVisitante) {
//       local.puntos += 3;
//     } else if (setsVisitante > setsLocal) {
//       visitante.puntos += 3;
//     } else {
//       local.puntos += 1;
//       visitante.puntos += 1;
//     }
//   });

//   const arr = Array.from(mapa.values());
//   arr.sort((a: any, b: any) => {
//     if (b.puntos !== a.puntos) return b.puntos - a.puntos;
//     const aSetDiff = a.setsGanados - a.setsPerdidos || 0;
//     const bSetDiff = b.setsGanados - b.setsPerdidos || 0;
//     if (bSetDiff !== aSetDiff) return bSetDiff - aSetDiff;
//     const aGameDiff = a.gamesGanados - a.gamesPerdidos || 0;
//     const bGameDiff = b.gamesGanados - b.gamesPerdidos || 0;
//     if (bGameDiff !== aGameDiff) return bGameDiff - aGameDiff;
//     return a.equipo.nombre.localeCompare(b.equipo.nombre);
//   });
//   return arr;
// }

// Agrega esta función al script
function hayResultadosEnFaseEliminacion() {
  if (!torneo.value?.rondas) return false;

  // Revisar todas las rondas de eliminación
  for (const ronda of torneo.value.rondas) {
    for (const partido of ronda.partidos) {
      // Verificar si hay resultado (excluyendo BYEs automáticos)
      if (partido.resultado && !partido.pasaAutomatico) {
        return true;
      }
      // O verificar si hay sets completados
      if (partido.sets && partido.sets.length > 0) {
        const setCompletado = partido.sets.some(
          (s: any) =>
            Number.isInteger(s.gamesLocal) &&
            Number.isInteger(s.gamesVisitante),
        );
        if (setCompletado) {
          return true;
        }
      }
    }
  }
  return false;
}

async function actualizarFaseEliminacion() {
  if (!torneo.value?.rondas || torneo.value.rondas.length === 0) return;

  try {
    // 1. Obtener PREDICCIÓN ORIGINAL desde utils con la estrategia correcta
    const estrategia = torneo.value.estrategiaByes || "orden_zonas";
    const prediccionOriginal = generarCrucesConByes(
      torneo.value.clasificadosPorZona,
      torneo.value.totalClasificados,
      estrategia, // Pasar la estrategia
    );

    // 2. Obtener clasificados REALES de las zonas
    const clasificados = obtenerClasificados();

    console.log("Clasificados obtenidos:", clasificados);
    console.log(
      "Mapa de predicciones guardado:",
      mapaPrediccionesEquipos.value.size,
    );

    // 3. Función para encontrar equipo por identificador - MODIFICADA para usar clasificados
    const crearEncontrarEquipo = (clasificadosArray: any[]) => {
      return (identificador: string) => {
        if (!identificador || typeof identificador !== "string") return null;

        console.log("Buscando equipo para identificador:", identificador);

        // PATRÓN 1: "Xº mejor de zona Y" (ej: "1º mejor de zona 1")
        const matchMejorDeZona = identificador.match(
          /(\d+)º mejor de zona (\d+)/,
        );
        if (matchMejorDeZona) {
          const nivel = parseInt(matchMejorDeZona[1]);
          const zona = parseInt(matchMejorDeZona[2]);

          console.log(`Buscando ${nivel}º mejor de zona ${zona}`);

          const equipo = clasificadosArray.find(
            (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
          );

          if (equipo) {
            console.log(
              `Encontrado: ${equipo.nombre} (zona ${zona}, ${nivel}º)`,
            );
          }

          return equipo || null;
        }

        // PATRÓN 2: "Xº de zona Y" (ej: "1º de zona 1")
        const matchZona = identificador.match(/(\d+)º de zona (\d+)/);
        if (matchZona) {
          const nivel = parseInt(matchZona[1]);
          const zona = parseInt(matchZona[2]);

          console.log(`Buscando ${nivel}º de zona ${zona}`);

          const equipo = clasificadosArray.find(
            (c) => c._meta && c._meta.zona === zona && c._meta.nivel === nivel,
          );

          if (equipo) {
            console.log(`Encontrado: ${equipo.nombre}`);
          }

          return equipo || null;
        }

        // PATRÓN 3: "Xº mejor Yº" (ej: "1º mejor 2º" = el mejor entre los segundos)
        const matchMejorComplejo = identificador.match(/(\d+)º mejor (\d+)º/);
        if (matchMejorComplejo) {
          const posicion = parseInt(matchMejorComplejo[1]);
          const nivel = parseInt(matchMejorComplejo[2]);

          console.log(`Buscando ${posicion}º mejor entre los ${nivel}º`);

          const equiposDelNivel = clasificadosArray
            .filter((c) => c._meta && c._meta.nivel === nivel)
            .sort((a, b) => {
              if (b._meta.puntos !== a._meta.puntos)
                return b._meta.puntos - a._meta.puntos;
              if (b._meta.setsDiff !== a._meta.setsDiff)
                return b._meta.setsDiff - a._meta.setsDiff;
              return b._meta.gamesDiff - a._meta.gamesDiff;
            });

          console.log(`Equipos del nivel ${nivel}:`, equiposDelNivel.length);

          if (posicion - 1 < equiposDelNivel.length) {
            const equipo = equiposDelNivel[posicion - 1];
            console.log("Encontrado:", equipo?.nombre);
            return equipo;
          }

          return null;
        }

        // PATRÓN 4: "Mejor Xº" (ej: "Mejor 2º")
        const matchMejorSimple = identificador.match(/Mejor (\d+)º/);
        if (matchMejorSimple) {
          const nivel = parseInt(matchMejorSimple[1]);

          console.log(`Buscando Mejor ${nivel}º`);

          const equiposNivel = clasificadosArray
            .filter((c) => c._meta && c._meta.nivel === nivel)
            .sort((a, b) => {
              if (b._meta.puntos !== a._meta.puntos)
                return b._meta.puntos - a._meta.puntos;
              if (b._meta.setsDiff !== a._meta.setsDiff)
                return b._meta.setsDiff - a._meta.setsDiff;
              return b._meta.gamesDiff - a._meta.gamesDiff;
            });

          if (equiposNivel.length > 0) {
            const equipo = equiposNivel[0];
            console.log("Encontrado:", equipo?.nombre);
            return equipo;
          }

          return null;
        }

        // PATRÓN 5: Solo "Mejor" (sin número)
        if (identificador.includes("Mejor") && !identificador.match(/\d/)) {
          console.log('Buscando "Mejor" (sin especificar nivel)');

          const todosOrdenados = clasificadosArray.sort((a, b) => {
            if (b._meta.puntos !== a._meta.puntos)
              return b._meta.puntos - a._meta.puntos;
            if (b._meta.setsDiff !== a._meta.setsDiff)
              return b._meta.setsDiff - a._meta.setsDiff;
            return b._meta.gamesDiff - a._meta.gamesDiff;
          });

          if (todosOrdenados.length > 0) {
            console.log("Encontrado:", todosOrdenados[0]?.nombre);
            return todosOrdenados[0];
          }
        }

        console.warn(`Patrón no reconocido: "${identificador}"`);
        return null;
      };
    };

    const encontrarEquipo = crearEncontrarEquipo(clasificados);
    const ronda1 = torneo.value.rondas[0];

    if (partidosOriginalesRonda1.value.length === 0) {
      // Guardar dos versiones: predicciones y equipos
      const prediccionesOriginales = JSON.parse(
        JSON.stringify(ronda1.partidos),
      );
      const equiposOriginales = JSON.parse(JSON.stringify(ronda1.partidos));

      // Para las predicciones, mantener strings
      // Para equipos, convertir strings a null para futura asignación
      prediccionesOriginales.forEach((partido: any) => {
        // Esta es la versión con predicciones (strings)
      });

      equiposOriginales.forEach((partido: any) => {
        // Esta es la versión que solo tiene la estructura, sin equipos asignados
        partido.local = null;
        partido.visitante = null;
        partido.ganador = null;
        partido.resultado = "";
        partido.pasaAutomatico = false;
        const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
        partido.sets = Array.from({ length: minimosRequeridos }, () => ({
          gamesLocal: null,
          gamesVisitante: null,
        }));
      });

      // Guardar ambas versiones
      partidosOriginalesPredicciones.value = prediccionesOriginales;
      partidosOriginalesEstructura.value = equiposOriginales;

      console.log("Partidos originales guardados en dos versiones");
    }

    // DECIDIR QUÉ ESTRATEGIA USAR
    // Importante: Usamos mapeo solo si hay predicciones guardadas
    if (mapaPrediccionesEquipos.value.size > 0) {
      console.log("Usando mapeo guardado de predicciones reorganizadas");
      await asignarEquiposConMapeo(ronda1, clasificados, encontrarEquipo);
    } else {
      console.log("Usando asignación original de predicciones");
      await asignarEquiposOriginal(
        ronda1,
        clasificados,
        prediccionOriginal,
        encontrarEquipo,
      );
    }

    await nextTick();
    calcularCurvas();
    partidoRefsReady.value = true;

    console.log("Fase de eliminación actualizada exitosamente");
  } catch (error) {
    console.error("Error en actualizarFaseEliminacion:", error);
    // Fallback a método simple
    await actualizarFaseEliminacionSimple();
  }
}

// Función de fallback simple
async function actualizarFaseEliminacionSimple() {
  const clasificados = obtenerClasificados();
  const ronda1 = torneo.value.rondas[0];
  const cuadroFinal = torneo.value.cuadroFinal;
  const totalClasificados = clasificados.length;

  const byes = cuadroFinal - totalClasificados;
  const mejoresConBye = clasificados.slice(0, byes);
  const restantes = clasificados.slice(byes);

  const participantes: any[] = [...mejoresConBye, ...restantes];
  while (participantes.length < cuadroFinal) {
    participantes.push(null);
  }

  ronda1.partidos.forEach((partido: any, idx: any) => {
    const local = participantes[idx];
    const visitante = participantes[cuadroFinal - 1 - idx];

    partido.local = local;
    partido.visitante = visitante;
    partido.pasaAutomatico = local === null || visitante === null;

    if (local && !visitante) {
      partido.ganador = local;
      partido.resultado = "BYE (avanza " + local.nombre + ")";
      actualizarSiguienteRonda(partido);
    } else if (!local && visitante) {
      partido.ganador = visitante;
      partido.resultado = "BYE (avanza " + visitante.nombre + ")";
      actualizarSiguienteRonda(partido);
    }
  });

  await nextTick();
  calcularCurvas();
  partidoRefsReady.value = true;
}

function actualizarSiguienteRonda(partido: any) {
  if (!torneo.value?.rondas || !partido.ganador) return;

  const rondaActual = torneo.value.rondas.find(
    (r: any) => r.numero === partido.ronda,
  );
  if (!rondaActual) return;

  const siguienteRonda = torneo.value.rondas.find(
    (r: any) => r.numero === partido.ronda + 1,
  );

  if (!siguienteRonda) {
    // Es la final
    campeonKey.value++;
    return;
  }

  // Encontrar índice del partido
  const indicePartido = rondaActual.partidos.findIndex(
    (p: any) => p.id === partido.id,
  );
  if (indicePartido === -1) return;

  // Calcular índice en la siguiente ronda
  const indicePartidoSiguiente = Math.floor(indicePartido / 2);
  const partidoSiguiente = siguienteRonda.partidos[indicePartidoSiguiente];

  if (!partidoSiguiente) return;

  // Guardar si tenía ganador antes
  const teniaGanadorAnterior = !!partidoSiguiente.ganador;

  // Determinar si viene como local o visitante
  const vieneComoLocal = indicePartido % 2 === 0;

  // Determinar lado del cuadro
  const totalPartidosRonda = rondaActual.partidos.length;
  const mitadPartidos = totalPartidosRonda / 2;
  const esLadoIzquierdo = indicePartido < mitadPartidos;

  if (vieneComoLocal) {
    partidoSiguiente.local = partido.ganador;
    console.log(
      `✓ ${partido.ganador.nombre} avanza como LOCAL a P${partidoSiguiente.id}`,
    );
  } else {
    partidoSiguiente.visitante = partido.ganador;
    console.log(
      `✓ ${partido.ganador.nombre} avanza como VISITANTE a P${partidoSiguiente.id}`,
    );
  }

  // ⭐ RESETEAR RESULTADO CON SETS SEGÚN DEPORTE
  if (partidoSiguiente.local && partidoSiguiente.visitante) {
    partidoSiguiente.ganador = null;
    partidoSiguiente.resultado = "";

    // ✅ CREAR SETS DINÁMICAMENTE
    const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
    partidoSiguiente.sets = Array.from({ length: minimosRequeridos }, () => ({
      gamesLocal: null,
      gamesVisitante: null,
    }));

    console.log(`✓ P${partidoSiguiente.id} listo para cargar resultado`);
  }

  // SI EL PARTIDO YA TENÍA GANADOR, PROPAGAR EL CAMBIO HACIA ADELANTE
  if (teniaGanadorAnterior) {
    console.log(
      `⚠ P${partidoSiguiente.id} tenía ganador, propagando a rondas posteriores...`,
    );
    propagarCambioHaciaRondasPosteriores(
      partidoSiguiente,
      esLadoIzquierdo,
      vieneComoLocal,
    );
  }
}

function propagarCambioHaciaRondasPosteriores(
  partidoSiguiente: any,
  esLadoIzquierdo: boolean,
  vieneComoLocal: boolean,
) {
  if (!torneo.value?.rondas || !partidoSiguiente) return;

  const rondaActualIndex = partidoSiguiente.ronda - 1;

  // ⭐ IMPORTANTE: Empezar desde ronda N+2 (skip la ronda que ya actualizamos)
  for (let i = rondaActualIndex + 1; i < torneo.value.rondas.length; i++) {
    const rondaPosterior = torneo.value.rondas[i];
    const rondaAnterior = torneo.value.rondas[i - 1];

    // Encontrar el partido en la ronda anterior
    const indicePartidoAnterior = rondaAnterior.partidos.findIndex(
      (p: any) => p.id === partidoSiguiente.id,
    );

    if (indicePartidoAnterior === -1) {
      console.log(`⚠️ No se encontró partido anterior P${partidoSiguiente.id}`);
      break;
    }

    // Calcular índice en la ronda posterior
    const indicePartidoPosterior = Math.floor(indicePartidoAnterior / 2);
    const partidoPosterior = rondaPosterior.partidos[indicePartidoPosterior];

    if (!partidoPosterior) break;

    console.log(
      `📤 Procesando ronda posterior ${i + 1}: P${partidoPosterior.id}`,
    );

    // ⭐ DETERMINAR QUÉ LADO DE ESTE PARTIDO VIENE DE LA RAMA AFECTADA
    const esLocalEnRondaAnterior = indicePartidoAnterior % 2 === 0;

    // ⭐ RESETEAR RESULTADO SIEMPRE
    partidoPosterior.ganador = null;
    partidoPosterior.resultado = "";
    const minimosRequeridos = deporte.value === "Futbol" ? 1 : 2;
    partidoPosterior.sets = Array.from({ length: minimosRequeridos }, () => ({
      gamesLocal: null,
      gamesVisitante: null,
    }));

    // ⭐ CONVERTIR EL LADO AFECTADO EN PREDICCIÓN
    if (esLocalEnRondaAnterior) {
      // El LOCAL viene de la rama afectada
      partidoPosterior.local = { nombre: `Ganador P${partidoSiguiente.id}` };
      console.log(
        `✅ Convertido LOCAL a predicción: Ganador P${partidoSiguiente.id}`,
      );

      // ⭐ MANTENER EL VISITANTE (del otro lado) SIN CAMBIOS
      // Solo si no hay visitante, establecer predicción
      if (!partidoPosterior.visitante) {
        const indiceOponente = indicePartidoAnterior + 1;
        const partidoOponente = rondaAnterior.partidos[indiceOponente];

        if (partidoOponente) {
          partidoPosterior.visitante = {
            nombre: `Ganador P${partidoOponente.id}`,
          };
          console.log(
            `✓ Establecido VISITANTE (predicción): Ganador P${partidoOponente.id}`,
          );
        }
      } else {
        console.log(
          `✓ Mantenido VISITANTE: ${partidoPosterior.visitante.nombre || "—"}`,
        );
      }
    } else {
      // El VISITANTE viene de la rama afectada
      partidoPosterior.visitante = {
        nombre: `Ganador P${partidoSiguiente.id}`,
      };
      console.log(
        `✅ Convertido VISITANTE a predicción: Ganador P${partidoSiguiente.id}`,
      );

      // ⭐ MANTENER EL LOCAL (del otro lado) SIN CAMBIOS
      // Solo si no hay local, establecer predicción
      if (!partidoPosterior.local) {
        const indiceOponente = indicePartidoAnterior - 1;
        const partidoOponente = rondaAnterior.partidos[indiceOponente];

        if (partidoOponente) {
          partidoPosterior.local = { nombre: `Ganador P${partidoOponente.id}` };
          console.log(
            `✓ Establecido LOCAL (predicción): Ganador P${partidoOponente.id}`,
          );
        }
      } else {
        console.log(
          `✓ Mantenido LOCAL: ${partidoPosterior.local.nombre || "—"}`,
        );
      }
    }

    // Actualizar referencia para la siguiente iteración
    partidoSiguiente = partidoPosterior;
  }
}

function obtenerClasificados() {
  if (!torneo.value?.zonas) return [];

  const clasificados: any[] = [];

  // Para cada zona
  torneo.value.zonas.forEach((zona: any, zonaIndex: any) => {
    const tabla = calcularTablaZona(zona, deporte.value);
    const cantClasificados = torneo.value.clasificadosPorZona[zonaIndex] || 0;

    // Tomar los clasificados de esta zona
    for (let i = 0; i < Math.min(cantClasificados, tabla.length); i++) {
      const fila = tabla[i];
      clasificados.push({
        id: fila.equipo.id,
        nombre: fila.equipo.nombre,
        _meta: {
          zona: zona.id,
          nivel: i + 1, // 1º, 2º, 3º, etc. en la zona
          puntos: fila.puntos,
          setsGanados: fila.setsGanados,
          setsPerdidos: fila.setsPerdidos,
          gamesGanados: fila.gamesGanados,
          gamesPerdidos: fila.gamesPerdidos,
          setsDiff: fila.setsGanados - fila.setsPerdidos,
          gamesDiff: fila.gamesGanados - fila.gamesPerdidos,
          pj: fila.pj,
        },
      });
    }
  });

  return clasificados;
}

function obtenerNombreRonda(numeroRonda: number, totalRondas: number): string {
  const rondasDesdeElFinal = totalRondas - numeroRonda + 1;

  if (rondasDesdeElFinal === 1) return "Final";
  if (rondasDesdeElFinal === 2) return "Semifinal";
  if (rondasDesdeElFinal === 3) return "Cuartos de Final";
  if (rondasDesdeElFinal === 4) return "Octavos de Final";

  // Para rondas anteriores, usar potencias de 2
  const equiposEnRonda = Math.pow(2, rondasDesdeElFinal);
  return `Ronda de ${equiposEnRonda}`;
}

// Función para abrir modal
async function abrirModalFinalizar() {
  const validacion = puedeFinalizarTorneo(torneo.value);

  if (!validacion.puede) {
    showAlert({
      icon: "warning",
      title: "No se puede finalizar",
      text: validacion.razon,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  jugadoresFinales.value = obtenerJugadoresOrdenadosTorneo(
    torneo.value,
    nombreTorneo.value,
    categoriaTorneo.value,
    generoTorneo.value,
  );

  if (jugadoresFinales.value.length === 0) {
    showAlert({
      icon: "warning",
      title: "Sin jugadores asignados",
      text: "No hay jugadores con asignación válida en este torneo.",
      timer: 4000,
      vm: proxy,
    });
    const datosTorneo = {
      nombre: "",
      descripcion: "",
      genero: null,
      categoria: null,
      fecha: "01/01/2025",
      tipoCompetencia: null,
      estado: "Finalizado",
      configuraciones: "",
      idTorneo: idTorneo.value,
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
    };

    await axios.post("/Torneos/CambiarEstado", datosTorneo);

    await guardarCambios();

    cambiarEstado("Finalizado");
    return;
  }

  modalFinalizarVisible.value = true;
}

// Función para finalizar
async function finalizarTorneo(jugadores: JugadorParaFinalizar[]) {
  try {
    const payload = {
      idTorneo: idTorneo.value,
      jugadores: JSON.stringify(
        jugadores.map((j) => ({
          idJugador: j.idJugador,
          nombreJugador: j.nombreJugador,
          posicion: j.ordenMerito,
          puntosAsignados: j.puntosAsignados,
        })),
      ),
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
    };

    await axios.post("/Ranking/GuardarRanking", payload);

    const datosTorneo = {
      nombre: "",
      descripcion: "",
      genero: null,
      categoria: null,
      fecha: "01/01/2025",
      tipoCompetencia: null,
      estado: "Finalizado",
      configuraciones: "",
      idTorneo: idTorneo.value,
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
    };

    await axios.post("/Torneos/CambiarEstado", datosTorneo);

    await guardarCambios();

    cambiarEstado("Finalizado");

    modalFinalizarVisible.value = false;

    showAlert({
      icon: "success",
      title: "¡Torneo Finalizado!",
      text: "Los puntos han sido asignados correctamente.",
      timer: 3000,
      vm: proxy,
    });
  } catch (error) {
    showAlert({
      icon: "error",
      title: "Error",
      text: "No se pudo finalizar el torneo.",
      timer: 4000,
      vm: proxy,
    });
  }
}

watch(
  () => {
    if (!torneo.value?.zonas) return null;

    // Crear una firma única solo de las zonas
    return torneo.value.zonas
      .map((zona: any) =>
        zona.partidos
          .map(
            (partido: any) =>
              partido.sets
                ?.map(
                  (set: any) =>
                    `${set.gamesLocal || "null"}-${
                      set.gamesVisitante || "null"
                    }`,
                )
                .join("|") || "empty",
          )
          .join(";"),
      )
      .join("||");
  },
  () => {
    if (todosResultadosZonas.value) {
      console.log(
        "✅ Todas las zonas completas, ejecutando actualizarFaseEliminacion",
      );
      actualizarFaseEliminacion();
    }
  },
  { deep: false }, // IMPORTANTE: deep: false porque ya manejamos la reactividad
);

watch(
  () => tab.value,
  (newTab, oldTab) => {
    if (newTab === 2 && torneo.value) {
      console.log(
        `📊 Cambiando a pestaña eliminación (modalidad: ${modalidad.value})`,
      );

      // Limpiar timeout anterior
      clearTimeout(timeoutCalculoCurvas);

      // Delay diferente según modalidad
      const delay = modalidad.value === "eliminacion_directa" ? 100 : 50;

      timeoutCalculoCurvas = setTimeout(() => {
        // Marcar refs como listos
        partidoRefsReady.value = true;

        // Forzar cálculo
        if (!calculandoCurvas.value) {
          forzarRecalculoCurvas();
        }
      }, delay);
    }
  },
);

let timeoutCalculoCurvas: any = null;

watch(
  () => todosResultadosZonas.value,
  (todosCompletos) => {
    if (todosCompletos && tab.value === 2) {
      // Cuando se completan todas las zonas y estamos en fase eliminación
      nextTick(() => {
        setTimeout(() => {
          forzarRecalculoCurvas();
        }, 50);
      });
    }
  },
);

// Watcher profundo
watch(
  () => torneo.value,
  (nuevoTorneo, viejoTorneo) => {
    if (!torneoOriginal.value) {
      // Guardar copia inicial
      torneoOriginal.value = JSON.parse(JSON.stringify(nuevoTorneo));
      hayCambiosSinGuardar.value = false;
      return;
    }

    // Comparar con la copia original
    const haCambiado =
      JSON.stringify(nuevoTorneo) !== JSON.stringify(torneoOriginal.value);
    hayCambiosSinGuardar.value = haCambiado;

    console.log("¿Torneo modificado?", haCambiado);
  },
  { deep: true, immediate: true },
);

// Función para resetear el estado de modificación
async function guardarCambios() {
  if (torneo.value) {
    torneoOriginal.value = JSON.parse(JSON.stringify(torneo.value));
    hayCambiosSinGuardar.value = false;
    console.log("Torneo marcado como guardado");

    const torneoGuardar = {
      idTorneo: proxy.$route.params.id,
      configuraciones: JSON.stringify(torneo.value),
      idInstitucion: proxy.$route.params.idInstitucion,
    };

    const response = await axios.post(
      "/Torneos/ModificarConfiguraciones",
      torneoGuardar,
    );

    console.log("response", response);
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 20px;
  background-color: #f3f4f6;
  min-height: 100vh;
  font-family: Arial, sans-serif;
}

h1 {
  font-size: 24px;
  margin-bottom: 16px;
}

.formulario {
  background: #fff;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
}

.form-row {
  margin-bottom: 12px;
}

.form-row label {
  margin-right: 8px;
  font-weight: bold;
}

input,
select {
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

button {
  background-color: #4f46e5;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: #4338ca;
}

button:disabled {
  background-color: #7a73e0;
  cursor: default;
}

@media (max-width: 590px) {
  .btn-generar-torneo {
    white-space: normal;
    padding: 0.75rem !important;
    display: block;
    height: auto !important;
    line-height: 1.4 !important;
  }

  .btn-generar-torneo :deep(.v-btn__content) {
    line-height: 1.4 !important;
    white-space: normal;
  }
}

.zonas {
  margin-bottom: 24px;
}

.zona-cards {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.zona-card {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  margin-bottom: 16px;
}

.zona-titulo {
  font-weight: bold;
  margin-bottom: 4px;
}

.criterio {
  margin-top: 8px;
  font-weight: bold;
}

.bracket-container {
  overflow-x: auto;
}

.rondas {
  display: flex;
  gap: 32px;
  position: relative;
}

.ronda-columna {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.titulo-ronda {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #4f46e5;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 2px solid #4f46e5;
}

.partidos-contenedor {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-grow: 1;
  gap: 16px;
}

.match-card {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  min-width: 303px;
}

.resultado {
  margin-top: 4px;
  font-weight: bold;
  color: #4f46e5;
}

.svg-conexiones {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.zonas-draggable {
  margin-top: 30px;
  :deep(.v-list-item__title) {
    font-size: 0.8rem;
  }
}

.zona-draggable-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.zona-draggable-card {
  width: 200px;
  background: white;
  padding: 14px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
}

.equipo-list {
  min-height: 150px;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 8px;
}

.equipo-item {
  background: #6366f1;
  color: white !important;
  padding: 6px 10px;
  border-radius: 6px;
  margin-bottom: 6px;
  cursor: grab;
}

.equipo-item:active {
  cursor: grabbing;
}

.edit-icon {
  margin-left: 6px;
  cursor: pointer;
}

.tabla-partidos,
.tabla-pos {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.tabla-partidos th,
.tabla-partidos td,
.tabla-pos th,
.tabla-pos td {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: center;
}

.input-res {
  width: 50px;
  text-align: center;
}

.match-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
}
.match-completado {
  border-color: #10b981;
  border-width: 4px;
  background: #f0fdf4;
}
.match-pendiente {
  border-color: #f59e0b;
  background: #fffbeb;
  border-width: 4px;
}
.match-bye {
  border-color: #10b981;
  background: #f0fdf4;
  opacity: 0.7;
}
.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}
.badge-completado {
  background: #d1fae5;
  color: #065f46;
}
.badge-pendiente {
  background: #fef3c7;
  color: #92400e;
}

.equipo-linea {
  transition: 0.25s ease;
}

.equipo-linea.ganador {
  font-weight: 800;
  font-size: 1.1rem;
  border-color: #10b981;
  background: #f0fdf4;
  font-weight: bold;
  color: #065f46;
}

.campeon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 200px;
  padding: 20px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(251, 191, 36, 0.4);
  animation: celebrar 1s ease-in-out;
  height: 250px;
  align-self: center;
  margin-top: 4rem;
}

@keyframes celebrar {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.campeon-trophy {
  font-size: 80px;
  animation: girar 2s ease-in-out infinite;
}

@keyframes girar {
  0%,
  100% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(10deg);
  }
}

.campeon-titulo {
  font-size: 24px;
  color: #92400e;
  margin: 10px 0 5px 0;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.campeon-nombre {
  font-size: 28px;
  color: #78350f;
  font-weight: bold;
  text-align: center;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
}
/* DRAGGABLE DE EQUIPOS */
.equipos-ronda1 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 10px 0;
}

.equipo-draggable {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 2px solid #e5e7eb;
  background: white;
  cursor: grab;
  transition: all 0.2s ease;
  min-height: 40px;
}

.equipo-draggable:active {
  cursor: grabbing;
}

.equipo-draggable:hover {
  border-color: #9ca3af;
  transform: translateY(-1px);
}

.equipo-draggable.drag-over {
  border: 2px dashed #4f46e5;
  background: rgba(79, 70, 229, 0.1);
}

.equipo-draggable.disabled-drag {
  cursor: not-allowed;
  opacity: 0.6;
}

.equipo-draggable.disabled-drag:hover {
  transform: none;
  border-color: #e5e7eb;
}

.drag-handle {
  opacity: 0.5;
  cursor: move;
}

.equipo-nombre {
  flex-grow: 1;
  font-weight: 500;
}

.posicion-indicator {
  font-size: 0.75rem;
  background: #6b7280;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: bold;
}

.vs-line {
  text-align: center;
  font-weight: bold;
  color: #4f46e5;
  margin: 4px 0;
}

/* BOTONES */
.btn-cargar-resultado {
  margin-top: 10px;
  background: #10b981;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  width: 100%;
}

.btn-cargar-resultado:hover {
  background: #0da271;
}

.bye-indicator {
  margin-top: 10px;
  padding: 6px;
  background: #d1fae5;
  color: #065f46;
  border-radius: 6px;
  text-align: center;
  font-weight: bold;
}

.reset-cruces-btn {
  background: #6b7280;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
}

.reset-cruces-btn:hover {
  background: #4b5563;
}

.drag-hint {
  font-size: 0.8rem;
  color: #6b7280;
  margin-left: 10px;
  font-weight: normal;
  font-style: italic;
}

/* Asegurar que el modal tenga z-index alto */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
/* CONTROLES DEL BRACKET */
.bracket-controls {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.btn-editar-predicciones {
  background: #8b5cf6;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
}

.btn-editar-predicciones:hover {
  background: #7c3aed;
  transform: translateY(-1px);
}

.btn-editar-predicciones.activo {
  background: #dc2626;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 38, 38, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);
  }
}

.instrucciones-edicion {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  padding: 12px 16px;
  border-radius: 8px;
  margin: 15px 0;
  border-left: 4px solid #4f46e5;
}

.instrucciones-edicion p {
  margin: 5px 0;
  color: #3730a3;
  font-size: 0.9rem;
}

/* PREDICCIONES EDITABLES */
.predicciones-editables {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 10px 0;
}

.prediccion-editable {
  padding: 10px 12px;
  border-radius: 6px;
  border: 2px solid #d1d5db;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
  min-height: 44px;
}

.prediccion-editable.draggable {
  cursor: grab;
  border-color: #9ca3af;
}

.prediccion-editable.draggable:active {
  cursor: grabbing;
}

.prediccion-editable.draggable:hover {
  border-color: #4f46e5;
  background: #f5f3ff;
  transform: translateY(-1px);
}

.prediccion-editable.bye {
  background: #f0fdf4;
  border-color: #86efac;
  color: #065f46;
}

.prediccion-texto {
  flex-grow: 1;
  font-weight: 500;
  color: #1f2937;
}

.bye-badge {
  background: #10b981;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: bold;
  margin-left: 8px;
}

.drag-indicator {
  opacity: 0.5;
  margin-left: 8px;
  cursor: move;
}

.prediccion-editable.draggable:hover .drag-indicator {
  opacity: 1;
  animation: bounce 1s infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}

/* EFECTO DURANTE DRAG */
.prediccion-editable.drag-over {
  border: 2px dashed #4f46e5;
  background: rgba(79, 70, 229, 0.1);
}

/* PARTIDOS EN MODO EDICIÓN */
.match-card.editable-prediccion {
  border: 2px solid #8b5cf6;
  background: #faf5ff;
  animation: borderGlow 3s infinite;
}

@keyframes borderGlow {
  0%,
  100% {
    box-shadow: 0 0 5px rgba(139, 92, 246, 0.5);
  }
  50% {
    box-shadow: 0 0 15px rgba(139, 92, 246, 0.8);
  }
}

/* PREDICCIONES NORMALES (cuando no se está editando) */
.predicciones-normales {
  text-align: center;
  margin: 10px 0;
}

.predicciones-normales div {
  padding: 8px;
  margin: 4px 0;
  background: #f3f4f6;
  border-radius: 4px;
  font-weight: 500;
}

/* RESPONSIVIDAD */
@media (max-width: 768px) {
  .bracket-controls {
    flex-direction: column;
  }

  .prediccion-editable {
    flex-direction: column;
    gap: 6px;
    text-align: center;
  }

  .prediccion-texto,
  .bye-badge,
  .drag-indicator {
    margin: 0;
  }
}
.estrategia-descripcion {
  margin-top: 4px;
  padding: 8px;
  background: #f3f4f6;
  border-radius: 6px;
  border-left: 3px solid #4f46e5;
}

.estrategia-descripcion small {
  color: #6b7280;
  font-size: 0.85rem;
}
.detalles-columna {
  max-width: 200px;
  min-width: 150px;
}

.detalles-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.85rem;
}

.detalle-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  background: #f3f4f6;
  border-radius: 4px;
}

.detalle-icon {
  font-size: 0.9rem;
  opacity: 0.8;
}

.detalle-observaciones {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 6px;
  background: #fef3c7;
  border-radius: 4px;
  font-style: italic;
  color: #92400e;
  font-size: 0.8rem;
  border-left: 3px solid #f59e0b;
}

.sin-detalles {
  color: #9ca3af;
  font-style: italic;
  font-size: 0.85rem;
  text-align: center;
  padding: 8px;
}

.acciones-columna {
  display: flex;
  gap: 8px;
  justify-content: center;
}

/* ESTILOS PARA MATCH CARD CON DETALLES */
.match-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.match-detalles-header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  font-size: 0.8rem;
}

.match-detalle {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  background: #f3f4f6;
  border-radius: 4px;
  color: #4b5563;
}

.match-ronda-dos-mas {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.observaciones {
  margin-top: 8px;
  padding: 6px 8px;
  background: #f0f9ff;
  border-radius: 6px;
  font-size: 0.85rem;
  color: #0369a1;
  border-left: 3px solid #0ea5e9;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.observaciones-icon {
  flex-shrink: 0;
  margin-top: 1px;
}

/* BOTONES EN MATCH CARD */
.match-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  justify-content: center;
}

.btn-match-detalles,
.btn-match-resultado,
.btn-match-editar-resultado {
  flex: 1;
  padding: 6px 10px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.btn-match-detalles {
  background: #8b5cf6;
  color: white;
}

.btn-match-detalles:hover {
  background: #7c3aed;
}

.btn-match-resultado {
  background: #10b981;
  color: white;
}

.btn-match-resultado:hover {
  background: #0da271;
}

.btn-match-editar-resultado {
  background: #3b82f6;
  color: white;
}

.btn-match-editar-resultado:hover {
  background: #2563eb;
}

/* RESPONSIVIDAD */
@media (max-width: 768px) {
  .match-header {
    flex-direction: column;
    gap: 8px;
  }

  .match-detalles-header {
    align-items: flex-start;
    width: 100%;
  }

  .match-detalle {
    width: 100%;
    justify-content: flex-start;
  }

  .match-actions {
    flex-direction: column;
  }

  .detalles-columna {
    max-width: 120px;
  }

  .detalle-item {
    font-size: 0.75rem;
    padding: 3px 4px;
  }
}
.estado-torneo-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.estado-badge {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.5s ease-out;
  position: relative;
  overflow: hidden;
  min-width: 140px;
  text-align: center;
  border: 2px solid transparent;
}

/* Animación de entrada */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estados específicos */
.estado-draft {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  color: #4b5563;
  border-color: #9ca3af;

  &::after {
    content: "✏️";
    margin-left: 8px;
    font-size: 1rem;
  }
}

.estado-publicado {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  color: white;
  border-color: #2563eb;
  animation: pulse 2s infinite;

  &::after {
    content: "🌐";
    margin-left: 8px;
    font-size: 1.1rem;
  }
}

.estado-finalizado {
  background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
  color: white;
  border-color: #059669;

  &::after {
    content: "🏆";
    margin-left: 8px;
    font-size: 1.1rem;
  }
}

/* Animación de pulso para estado "PUBLICADO" */
@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  }
  50% {
    box-shadow: 0 4px 20px rgba(59, 130, 246, 0.5),
      0 0 30px rgba(59, 130, 246, 0.2);
  }
}

/* Indicador de herramienta (tooltip) */
.estado-badge:hover::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  right: 0;
  background: #1f2937;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.85rem;
  white-space: nowrap;
  margin-bottom: 8px;
  font-weight: normal;
  z-index: 1001;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* SELECTOR DE ESTADO */
.estado-selector {
  background: #f8fafc;
  padding: 12px;
  border-radius: 8px;
  margin-top: 16px;
  border-left: 4px solid #4f46e5;
}

.estado-selector label {
  font-weight: bold;
  color: #374151;
  margin-right: 12px;
}

.estado-selector select {
  padding: 6px 12px;
  border-radius: 6px;
  border: 2px solid #d1d5db;
  background: white;
  font-weight: 500;
  color: #1f2937;
  cursor: pointer;
  transition: all 0.2s;
}

.estado-selector select:hover {
  border-color: #9ca3af;
}

.estado-selector select:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

/* Ajustes responsive */
@media (max-width: 768px) {
  .estado-torneo-container {
    position: relative;
    top: auto;
    right: auto;
    margin-bottom: 20px;
    align-items: center;
  }

  .estado-badge {
    font-size: 1rem;
    padding: 10px 20px;
    min-width: 120px;
  }

  .estado-selector {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .estado-selector label {
    margin-right: 0;
  }
}

/* Para pantallas muy pequeñas */
@media (max-width: 480px) {
  .estado-badge {
    font-size: 0.9rem;
    padding: 8px 16px;
    min-width: 100px;
  }
}

/* Estilo adicional para cuando el torneo está vacío */
.container:has(.estado-badge) {
  position: relative;
}

.equipo-list {
  min-height: 150px;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 8px;
  transition: all 0.3s ease;
}

.equipo-item {
  background: #6366f1;
  color: white !important;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: grab;
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
  position: relative;
}

.equipo-item:active {
  cursor: grabbing;
  transform: scale(0.98);
  opacity: 0.8;
}

.equipo-item.dragging {
  opacity: 0.5;
  background: #4f46e5;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}

/* Feedback visual durante el drag */
.zona-draggable-card.drag-over-zone {
  border: 2px dashed #10b981;
  background: rgba(16, 185, 129, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

/* Efecto al pasar sobre una zona válida */
.zona-draggable-card:hover:not(.drag-over-zone) {
  border-color: #9ca3af;
  transform: translateY(-1px);
}

/* Indicador visual de zona de drop */
.zona-draggable-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 10px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
}

.zona-draggable-card.drag-over-zone::after {
  opacity: 1;
  background: linear-gradient(
    135deg,
    rgba(16, 185, 129, 0.1) 0%,
    transparent 50%
  );
}

/* Iconos de edición */
.edit-icon {
  margin-left: 8px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
  padding: 2px;
  border-radius: 3px;
}

.edit-icon:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.2);
}

/* Contenedor de zonas */
.zona-draggable-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.zona-draggable-card {
  width: 220px;
  background: white;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  border: 2px solid transparent;
  transition: all 0.3s ease;
  position: relative;
  min-height: 300px;
  display: flex;
  flex-direction: column;
}

.zona-draggable-card h3 {
  margin-top: 0;
  color: #4f46e5;
  padding-bottom: 10px;
  border-bottom: 2px solid #f3f4f6;
  margin-bottom: 15px;
}

/* Indicador de capacidad de la zona */
.capacidad-zona {
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 5px;
  text-align: center;
}

.capacidad-zona.llena {
  color: #dc2626;
  font-weight: bold;
}

/* Mensaje cuando no hay equipos */
.equipo-list:empty::after {
  content: "Arrastra equipos aquí";
  display: block;
  text-align: center;
  padding: 20px;
  color: #9ca3af;
  font-style: italic;
}

/* Responsive */
@media (max-width: 768px) {
  .zona-draggable-container {
    flex-direction: column;
    align-items: center;
  }

  .zona-draggable-card {
    width: 100%;
    max-width: 300px;
  }

  .equipo-item {
    :deep(.v-list-item__title) {
      white-space: pre-wrap;
    }
  }

  .edit-icon {
    align-self: flex-end;
  }
}
.equipo-linea-ronda2 {
  padding: 8px 12px;
  border-radius: 6px;
  margin: 4px 0;
  transition: all 0.2s;
  border: 2px solid transparent;
  position: relative;
}

.equipo-linea-ronda2.ganador {
  border-color: #10b981;
  background: #f0fdf4;
  font-weight: bold;
  color: #065f46;
}

.equipo-linea-ronda2.prediccion-temporal {
  border-style: dashed;
  border-color: #f59e0b;
  background: #fffbeb;
  color: #92400e;
}

.prediccion-badge {
  font-size: 0.7rem;
  background: #f59e0b;
  color: white;
  padding: 1px 6px;
  border-radius: 10px;
  margin-left: 8px;
  font-weight: normal;
}

/* Estados específicos */
.match-card .match-ronda-dos-mas .equipo-linea-ronda2 {
  text-align: center;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.zonas-wrapper {
  overflow-x: auto;
}

.rondas-wrapper {
  overflow-x: auto;
  padding-bottom: 24px;
}

.rondas {
  display: flex;
  gap: 32px;
  position: relative;
  min-width: fit-content;
}

.zona-card {
  transition: all 0.3s;
  border: 2px solid transparent;
}

.zona-card.drag-over-zone {
  border: 2px dashed #4caf50;
  background-color: rgba(76, 175, 80, 0.1);
}

.equipo-item {
  cursor: grab;
  transition: background-color 0.2s;
}

.equipo-item:active {
  cursor: grabbing;
}

.equipo-item:hover {
  background-color: rgba(99, 102, 241, 0.4);
}

/* Ajustes responsive */
@media (max-width: 960px) {
  .rondas {
    gap: 16px;
  }

  .match-card {
    min-width: 280px;
  }
}

@media (max-width: 600px) {
  .rondas {
    flex-direction: column;
    gap: 24px;
  }

  .ronda-columna {
    width: 100%;
  }

  .match-card {
    min-width: 100%;
  }
}
.v-data-table td,
.v-data-table th {
  text-align: left !important;
}

.v-data-table td {
  vertical-align: middle !important;
}

/* Para tablas específicas de zonas */
.zonas-tabla .v-data-table td,
.zonas-tabla .v-data-table th {
  text-align: left !important;
  padding: 8px 16px !important;
}

/* Asegurar que las celdas de acciones mantengan alineación */
.acciones-cell {
  text-align: center !important;
  white-space: nowrap;
}
.rondas-wrapper {
  position: relative;
  overflow-x: auto;
  padding: 20px 0;
  min-height: 600px;
}

.rondas-container {
  position: relative;
  min-width: fit-content;
}

.svg-conexiones {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1; /* Por debajo de los partidos */
}

.conexion-linea {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
  transition: stroke 0.3s ease;
}

.conexion-linea:hover {
  stroke: #7c3aed;
  stroke-width: 4;
}

/* Asegurar que los partidos estén por encima */
.ronda-columna {
  position: relative;
  z-index: 2;
}

.match-card {
  position: relative;
  z-index: 3;
  background: white; /* Fondo sólido para tapar líneas */
}

/* Debug: mostrar contenedor */
.rondas-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px dashed #078152;
  pointer-events: none;
  z-index: 0;
}
/* ==================== */
/* 1. MEJORAR CONTRASTE */
/* ==================== */

/* ZONAS - Contraste mejorado en cards de equipos */
.zona-card {
  .v-card-title {
    color: #1976d2 !important; /* Azul más oscuro */
    font-weight: 600;
  }

  .v-chip {
    color: white !important;
    font-weight: bold;
    background-color: #343434;
  }
}

/* Botones de acción en zonas */
.acciones-cell {
  .botones-accion {
    display: flex !important;
    gap: 8px !important;
    justify-content: center !important;
  }
}

/* Botón Detalles - Azul oscuro */
.v-btn[icon]:has(.mdi-information) {
  background-color: #1565c0 !important;
  color: white !important;
  border-radius: 4px;
  width: auto !important;
  padding: 0 12px !important;

  &::before {
    content: "Detalles" !important;
    margin-right: 4px;
    font-size: 0.75rem;
    font-weight: 500;
  }

  .v-icon {
    font-size: 16px !important;
  }
}

/* Botón Resultado - Verde oscuro */
.v-btn[icon]:has(.mdi-soccer) {
  background-color: #2e7d32 !important;
  color: white !important;
  border-radius: 4px;
  width: auto !important;
  padding: 0 12px !important;

  &::before {
    content: "Resultado" !important;
    margin-right: 4px;
    font-size: 0.75rem;
    font-weight: 500;
  }

  .v-icon {
    font-size: 16px !important;
  }
}

/* Para hover */
.v-btn[icon]:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* =============================== */
/* 2. BOTONES EN FASE ELIMINACIÓN */
/* =============================== */

.match-actions {
  .v-btn {
    min-width: 100px !important;
    height: 32px !important;
    font-size: 0.8rem !important;
    font-weight: 500 !important;
    text-transform: none !important;
    color: white !important;

    /* Contraste mejorado */
    &.grey {
      background-color: #5d5d5d !important;
      color: white !important;
    }

    &.primary {
      background-color: #1976d2 !important;
      color: white !important;
    }

    &.warning {
      background-color: #ed6c02 !important;
      color: white !important;
    }

    .v-icon {
      margin-right: 6px !important;
    }
  }
}

/* Botón "Detalles" en eliminación - más contraste */
.btn-match-detalles {
  background: #1565c0 !important;
  color: white !important;
  font-weight: 500;

  &:hover {
    background: #0d47a1 !important;
  }
}

/* ============================ */
/* 3. SEPARACIÓN DE BOTONES EN FIXTURE */
/* ============================ */

/* Asegurar separación clara en tabla de fixture */
.zonas-tabla {
  .acciones-cell {
    padding: 8px 16px !important;

    /* Contenedor flexible con espacio */
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 12px !important; /* Espacio entre botones */

    /* Línea divisoria visual */
    border-left: 1px solid #e0e0e0;
    min-height: 70px; /* Altura mínima para evitar compresión */
  }
}

/* ============================ */
/* 4. CURVAS EN ZONAS + ELIMINACIÓN */
/* ============================ */

/* Asegurar que el SVG tenga el tamaño correcto */
.svg-conexiones {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

/* Contenedor de rondas con altura fija */
.rondas-container {
  position: relative;
  min-height: 800px; /* Altura mínima para que las curvas se vean */
}

/* Forzar recálculo cuando se cambia de pestaña */
.v-tabs-items {
  position: relative;
  overflow: visible !important;
}

/* ============================ */
/* 5. MEJORAS GENERALES DE CONTRASTE */
/* ============================ */

/* Texto en cards */
.v-card-title {
  color: rgba(0, 0, 0, 0.87) !important; /* Negro más oscuro */
  font-weight: 600 !important;
}

/* Chips con mejor contraste */
.v-chip {
  &.success {
    background-color: #2e7d32 !important;
    color: white !important;
  }

  &.warning {
    background-color: #ed6c02 !important;
    color: white !important;
  }

  &.primary {
    background-color: #1976d2 !important;
    color: white !important;
  }
}

/* Tablas más legibles */
.zonas-tabla {
  th {
    background-color: #f5f5f5 !important;
    color: #333 !important;
    font-weight: 600 !important;
  }

  tr:hover {
    background-color: #f9f9f9 !important;
  }
}

/* ============================ */
/* RESPONSIVE */
/* ============================ */

@media (max-width: 960px) {
  .acciones-cell {
    flex-direction: column !important;
    gap: 6px !important;

    .v-btn {
      width: 100% !important;
      margin: 2px 0 !important;
    }
  }

  .zonas-tabla .v-btn {
    width: 90px !important;
    height: 32px !important;
  }
}

@media (max-width: 600px) {
  .acciones-cell {
    border-left: none !important;
    border-top: 1px solid #e0e0e0;
    padding-top: 12px !important;
  }

  /* Ocultar texto, solo íconos en móvil */
  .v-btn[icon]::before {
    display: none !important;
  }

  .v-btn[icon] {
    width: 36px !important;
    height: 36px !important;
    padding: 0 !important;
  }
}
.detalle-icon {
  background-color: white;
  border-radius: 50%;
  padding: 2px;
  margin-right: 0.5rem;
}
.nombre-ronda {
  color: white;
}
.fase-detalles {
  width: 100%;
}
.tabla-partidos {
  :deep(tbody td) {
    font-weight: 600;
    &:last-child {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    .v-data-table__mobile-row__cell:last-child {
      display: flex;
      gap: 0.75rem;
    }
  }
  :deep(.ganador-border) {
    color: green;
  }
  :deep(.perdedor-border) {
    color: red;
  }
}
.torneo-configurado {
  position: absolute;
  right: 1.1rem;
  border: 1px solid orange;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  background: oldlace;
  color: black;
  font-size: 16px;
}
// Estilos para el menú dropdown
.v-menu__content {
  .v-list {
    padding: 4px 0;
  }

  .v-list-item {
    min-height: 36px;
    padding: 0 12px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }

  .v-list-item__icon {
    margin-right: 12px;
    min-width: 24px;
  }

  .v-list-item__title {
    font-size: 0.875rem;
  }

  .v-divider {
    margin: 4px 0;
  }
}

// Ajuste para el botón de menú en equipos
.equipo-item {
  .v-list-item__action {
    margin: 0;
    margin-left: 8px;
  }
}

// Ajuste para las cards de predicciones normales
.predicciones-normales {
  .v-card-text {
    gap: 8px;
  }
}
.mensaje-byes {
  border: 1px solid orange;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  background: oldlace;
  color: black;
  font-size: 16px;
}
.bracket-title {
  display: flex;
  flex-wrap: wrap;
}
</style>
